import React from 'react'

const SvgBanner = props => (
  <svg
    id='banner_svg__Layer_1'
    x={0}
    y={0}
    viewBox='0 0 440 360'
    xmlSpace='preserve'
    enableBackground='new 0 0 440 360'
    {...props}
  >
    <style>
      {
        '.banner_svg__st2{fill:#f3f6ff}.banner_svg__st10{enable-background:new}.banner_svg__st46{fill:#d4dffc}.banner_svg__st77{fill:none;stroke:#000;stroke-miterlimit:10}.banner_svg__st160{fill:#bdd0ff}.banner_svg__st163{fill:#fff}.banner_svg__st168{fill:#012860}'
      }
    </style>
    <linearGradient
      id='banner_svg__SVGID_1_'
      gradientUnits='userSpaceOnUse'
      x1={84.913}
      y1={266.431}
      x2={292.07}
      y2={269.95}
    >
      <stop offset={0} stopColor='#e9f1ff' />
      <stop offset={1} stopColor='#d4e0ff' />
    </linearGradient>
    <path
      d='M187.02 323.67c-12.3 0-24.77-1.18-36.85-3.66-32.63-6.72-56.26-21.72-63.23-40.13-4.05-10.7-2.13-21.76 5.55-31.97 21.25-28.25 81.51-42.39 134.32-31.52 32.63 6.72 56.26 21.72 63.23 40.13 4.05 10.7 2.13 21.76-5.55 31.97-16.39 21.78-55.99 35.18-97.47 35.18zm2.77-108.56c-40.69 0-79.39 13.02-95.36 34.24-7.16 9.51-8.96 19.77-5.22 29.66 6.67 17.63 29.64 32.07 61.45 38.62 51.98 10.7 111.15-3.03 131.89-30.61 7.16-9.51 8.96-19.77 5.22-29.66-6.67-17.63-29.64-32.07-61.45-38.62-11.97-2.46-24.35-3.63-36.53-3.63z'
      fill='url(#banner_svg__SVGID_1_)'
    />
    <linearGradient
      id='banner_svg__SVGID_2_'
      gradientUnits='userSpaceOnUse'
      x1={127.756}
      y1={267.202}
      x2={244.076}
      y2={269.178}
    >
      <stop offset={0} stopColor='#e9f1ff' />
      <stop offset={1} stopColor='#d4e0ff' />
    </linearGradient>
    <path
      d='M185.09 299.34c-6.91 0-13.91-.66-20.69-2.06-18.32-3.77-31.59-12.2-35.5-22.54-2.27-6.01-1.19-12.22 3.12-17.95 11.93-15.86 45.77-23.8 75.42-17.7 18.32 3.77 31.59 12.2 35.5 22.54 2.27 6.01 1.19 12.22-3.12 17.95-9.21 12.24-31.44 19.76-54.73 19.76zm1.55-60.95c-22.85 0-44.58 7.31-53.54 19.23-4.02 5.34-5.03 11.1-2.93 16.65 3.74 9.9 16.64 18.01 34.5 21.68 29.19 6.01 62.41-1.7 74.06-17.18 4.02-5.34 5.03-11.1 2.93-16.65-3.74-9.9-16.64-18.01-34.5-21.68-6.73-1.4-13.67-2.05-20.52-2.05z'
      fill='url(#banner_svg__SVGID_2_)'
    />
    <path className='banner_svg__st2' d='M73.41 248.53l28.36 16.37 70.99-40.97-28.39-16.37z' />
    <linearGradient
      id='banner_svg__SVGID_3_'
      gradientUnits='userSpaceOnUse'
      x1={16.602}
      y1={154.276}
      x2={201.14}
      y2={154.276}
    >
      <stop offset={0} stopColor='#e9f1ff' />
      <stop offset={1} stopColor='#d4e0ff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_3_)' d='M16.6 133.78L201.14 27.25v147.52L16.62 281.3z' />
    <linearGradient
      id='banner_svg__SVGID_4_'
      gradientUnits='userSpaceOnUse'
      x1={9.504}
      y1={205.49}
      x2={16.617}
      y2={205.49}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_4_)' d='M16.62 281.3l-7.12-4.11V129.68l7.1 4.1z' />
    <linearGradient
      id='banner_svg__SVGID_5_'
      gradientUnits='userSpaceOnUse'
      x1={9.504}
      y1={78.462}
      x2={201.14}
      y2={78.462}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_5_)' d='M9.5 129.68L194.04 23.15l7.1 4.1L16.6 133.78z' />
    <path className='banner_svg__st2' d='M23.71 137.88V269l170.34-98.34V39.54z' />
    <linearGradient
      id='banner_svg__SVGID_6_'
      gradientUnits='userSpaceOnUse'
      x1={101.812}
      y1={228.04}
      x2={144.369}
      y2={228.04}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_6_)' d='M101.81 232.14v16.38l42.56-24.59v-16.37z' />
    <linearGradient
      id='banner_svg__SVGID_7_'
      gradientUnits='userSpaceOnUse'
      x1={87.57}
      y1={240.333}
      x2={101.812}
      y2={240.333}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_7_)' d='M101.81 248.52l-14.24-8.18 14.24-8.2z' />
    <linearGradient
      id='banner_svg__SVGID_8_'
      gradientUnits='userSpaceOnUse'
      x1={70.659}
      y1={258.297}
      x2={101.774}
      y2={258.297}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_8_)' d='M101.77 268.06v-3.16l-28.36-16.37-2.75 1.57z' />
    <linearGradient
      id='banner_svg__SVGID_9_'
      gradientUnits='userSpaceOnUse'
      x1={80.818}
      y1={115.575}
      x2={131.744}
      y2={115.575}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#aac9ff' />
      <stop offset={1} stopColor='#e9f1ff' />
    </linearGradient>
    <path
      d='M136.7 142.57c-.25 15.46-10.91 33.49-23.81 40.26-12.9 6.77-23.15-.27-22.9-15.74.25-15.46 10.91-33.49 23.81-40.26 12.9-6.77 23.15.27 22.9 15.74z'
      fill='url(#banner_svg__SVGID_9_)'
    />
    <g className='banner_svg__st10'>
      <defs>
        <path
          id='banner_svg__SVGID_10_'
          className='banner_svg__st10'
          d='M93.07 166.83l-5.09-28.1 43.32-2.23 5.09 28.1z'
        />
      </defs>
      <clipPath id='banner_svg__SVGID_11_'>
        <use xlinkHref='#banner_svg__SVGID_10_' overflow='visible' />
      </clipPath>
      <g clipPath='url(#banner_svg__SVGID_11_)'>
        <defs>
          <path id='banner_svg__SVGID_12_' d='M135.48 164.64l-47.42-25.47.83-.49 47.42 25.48-.83.48' />
        </defs>
        <clipPath id='banner_svg__SVGID_13_'>
          <use xlinkHref='#banner_svg__SVGID_12_' overflow='visible' />
        </clipPath>
        <path
          d='M135.51 164.25l-.03.4c0-.03.01-.05.01-.08.02-.11.02-.21.02-.32m-46.62-25.57c-.03.09-.05.19-.06.3 0 .03-.01.05-.01.08.02-.13.05-.26.07-.38'
          clipPath='url(#banner_svg__SVGID_13_)'
        />
      </g>
    </g>
    <linearGradient
      id='banner_svg__SVGID_14_'
      gradientUnits='userSpaceOnUse'
      x1={107.245}
      y1={115.311}
      x2={107.363}
      y2={115.311}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M114.74 123.23c.04-.01.07-.03.11-.05-.04.02-.08.03-.11.05zm-1 61.69c.04-.02.07-.04.11-.06-.04.02-.08.04-.11.06z'
      fill='url(#banner_svg__SVGID_14_)'
    />
    <linearGradient
      id='banner_svg__SVGID_15_'
      gradientUnits='userSpaceOnUse'
      x1={77.053}
      y1={115.311}
      x2={135.358}
      y2={115.311}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M133.41 122.62c-.22-.18-.44-.35-.68-.51l-.18-.12c-4.69-3.23-10.92-3.22-17.64-.02-.27.13-.55.27-.82.41l-.03.02c-.09.04-.17.09-.26.13-7.14 3.75-13.91 10.61-19.06 19.32-.06.1-.12.21-.18.31-.24.41-.47.82-.7 1.24-4.6 8.28-7.18 17.17-7.31 25.23-.13 7.79 2.06 13.95 6.18 17.56.21.19.43.37.65.54.2.16.41.31.63.46 4.95 3.4 11.61 3.21 18.76-.54.09-.05.17-.09.26-.14l.03-.02c.28-.15.55-.3.83-.46 6.73-3.86 13.07-10.45 17.95-18.71.22-.38.44-.75.65-1.13.23-.41.46-.82.68-1.24 4.32-8.04 6.74-16.62 6.86-24.41.12-8.06-2.22-14.37-6.62-17.92zm-37.98 19.69c3.83-6.48 8.6-11.9 13.74-15.69-2.31 2.77-4.44 6.52-6.24 11.04a63.58 63.58 0 00-1.62 4.59c-2.17.33-4.15.35-5.88.06 0 .01 0 .01 0 0zm-.72 1.26c.03.01.07.01.11.02 1.83.31 3.88.3 6.1-.04a73.252 73.252 0 00-2.85 18.43l-10.51 5.52c.24-7.68 2.76-16.1 7.15-23.93zm-1.12 41.51c-3.92-3.37-6.05-9.11-6.05-16.39l10.51-5.52c-.04 5.8.67 10.94 2.05 15.02a59.61 59.61 0 00-5.94 6.19c-.2.23-.39.47-.57.7zm1.14.88c-.16-.11-.32-.23-.48-.35 1.81-2.23 3.89-4.42 6.19-6.49.51 1.35 1.1 2.56 1.77 3.63 1.68 2.69 3.73 4.25 5.99 4.62-5.12 1.59-9.79 1.13-13.47-1.41zm18.01-.51c-4.78 2.18-8.91-.78-11.35-7.17 3.5-3.03 7.44-5.78 11.6-7.97l-.25 15.14zm.27-16.34c-4.21 2.21-8.28 5.02-11.95 8.22-1.32-3.88-2.06-8.89-2.02-14.69l14.19-7.45-.22 13.92zm.24-15.11l-14.19 7.45c.16-6.22 1.18-12.46 2.81-18.06 3.57-.66 7.52-2.09 11.62-4.24l-.24 14.85zm.26-16.04c-4.04 2.12-7.86 3.48-11.25 4.13 2.71-8.64 6.86-15.58 11.48-18.33l-.23 14.2zm25.52 2.51l-9.6 5.04c.05-6.26-.79-11.77-2.4-15.98 1.94-1.8 3.75-3.71 5.39-5.69.04-.04.07-.09.11-.13 4.22 3.31 6.51 9.21 6.5 16.76zm-7.19-17.28c.01.01.01.01 0 0a56.944 56.944 0 01-5.17 5.43c-.42-.98-.88-1.88-1.39-2.7-1.56-2.5-3.44-4.02-5.51-4.53 4.56-1.09 8.72-.5 12.07 1.8zm-17.1.04c.04-.02.07-.03.11-.05 4.5-1.98 8.41.59 10.87 6.3-3.37 2.99-7.18 5.72-11.21 7.94l.23-14.19zm-.25 15.38c4.09-2.25 8.04-5.06 11.59-8.22 1.53 4 2.4 9.35 2.36 15.64l-14.19 7.45.24-14.87zm-.26 16.06l14.19-7.45c-.15 5.99-1.1 11.99-2.63 17.43-3.58.52-7.6 1.86-11.79 3.96l.23-13.94zm-.38 30.19c-.04.02-.07.04-.11.06l.25-15.13c4.14-2.07 8.03-3.34 11.43-3.84-2.68 8.87-6.89 16.05-11.57 18.91zm17.29-18.02c-3.48 5.89-7.74 10.91-12.35 14.62 2.12-2.71 4.08-6.24 5.76-10.44.67-1.67 1.27-3.41 1.81-5.19 1.95-.21 3.73-.16 5.28.15-.17.29-.34.58-.5.86zm1.19-2.1c-.18-.04-.37-.08-.56-.11-1.53-.26-3.22-.29-5.04-.1 1.6-5.72 2.54-11.85 2.69-17.83l9.6-5.04c-.24 7.4-2.59 15.49-6.69 23.08z'
      fill='url(#banner_svg__SVGID_15_)'
    />
    <path d='M114.26 122.28c-.06.03-.11.06-.17.09.28-.14.55-.28.82-.41-.21.1-.43.21-.65.32zm-1.21 64.2c.06-.03.11-.06.17-.09.22-.11.44-.24.66-.37-.28.16-.55.31-.83.46z' />
    <linearGradient
      id='banner_svg__SVGID_16_'
      gradientUnits='userSpaceOnUse'
      x1={70.208}
      y1={115.323}
      x2={142.845}
      y2={115.323}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M110.83 112.53l-27.25 32.8c.21.18.39.41.52.69l27.03-32.54a3.12 3.12 0 01-.3-.95zm6.91-3.63c-.07.43-.19.87-.34 1.29l25.68 4.34c.17-.43.37-.85.61-1.25l-25.95-4.38zm28.47 10.22l-.59 36.69c.08-.05.17-.1.25-.14.25-.13.49-.23.72-.29l.6-36.99c-.31.29-.64.53-.98.73zm-3.6 44.27l-26.55 31.96c.14.28.24.61.29.98l26.8-32.26c-.23-.17-.41-.4-.54-.68zM83.82 194.3c-.13.43-.3.86-.51 1.27l26.1 4.41c.06-.43.17-.87.32-1.3l-25.91-4.38zm-2.99-40.57c-.09.05-.18.09-.27.13l-.6 36.76c.22-.17.45-.32.69-.44.1-.05.19-.1.29-.14l.6-36.77c-.23.18-.47.33-.71.46z'
      fill='url(#banner_svg__SVGID_16_)'
    />
    <linearGradient
      id='banner_svg__SVGID_17_'
      gradientUnits='userSpaceOnUse'
      x1={73.762}
      y1={98.666}
      x2={81.203}
      y2={98.666}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path d='M90.62 150.12l-.52 1.27-6.25-1.22c.18-.42.32-.85.42-1.29l6.35 1.24z' fill='url(#banner_svg__SVGID_17_)' />
    <linearGradient
      id='banner_svg__SVGID_18_'
      gradientUnits='userSpaceOnUse'
      x1={130.96}
      y1={99.041}
      x2={138.71}
      y2={99.041}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path d='M143.42 119.15l-6.68 8.21-.48-.74 6.65-8.17c.12.29.3.52.51.7z' fill='url(#banner_svg__SVGID_18_)' />
    <linearGradient
      id='banner_svg__SVGID_19_'
      gradientUnits='userSpaceOnUse'
      x1={130.96}
      y1={131.79}
      x2={138.972}
      y2={131.79}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path d='M136.24 157.55l6.77 1.32c-.2.41-.36.84-.48 1.27l-6.8-1.32.51-1.27z' fill='url(#banner_svg__SVGID_19_)' />
    <linearGradient
      id='banner_svg__SVGID_20_'
      gradientUnits='userSpaceOnUse'
      x1={73.862}
      y1={131.783}
      x2={81.912}
      y2={131.783}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path d='M90.74 182.43l-6.93 8.51a2.08 2.08 0 00-.51-.7l6.96-8.55.48.74z' fill='url(#banner_svg__SVGID_20_)' />
    <linearGradient
      id='banner_svg__SVGID_21_'
      gradientUnits='userSpaceOnUse'
      x1={66.669}
      y1={95.065}
      x2={74.344}
      y2={95.065}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M84.11 146.02c-.14-.28-.31-.51-.52-.69-.63-.54-1.56-.6-2.61-.05-1.94 1.02-3.55 3.74-3.59 6.07-.04 2.22 1.37 3.29 3.18 2.5.09-.04.18-.08.27-.13.24-.13.48-.28.7-.45.97-.74 1.8-1.87 2.31-3.11.18-.42.32-.85.42-1.29.1-.41.15-.82.15-1.23.01-.63-.1-1.18-.31-1.62zm-.71 2.7c-.07.43-.2.87-.38 1.29-.34.8-.86 1.54-1.47 2.06-.22.19-.46.36-.7.49-.09.05-.18.09-.27.13-1.27.51-2.25-.27-2.22-1.84.03-1.68 1.19-3.65 2.59-4.39.69-.36 1.31-.36 1.76-.07.23.15.42.37.54.67.13.3.2.68.2 1.11-.01.18-.02.36-.05.55z'
      fill='url(#banner_svg__SVGID_21_)'
    />
    <linearGradient
      id='banner_svg__SVGID_22_'
      gradientUnits='userSpaceOnUse'
      x1={67.121}
      y1={136.088}
      x2={74.797}
      y2={136.088}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#f22aff' />
      <stop offset={1} stopColor='#6c00e9' />
    </linearGradient>
    <path
      d='M83.81 190.95a2.08 2.08 0 00-.51-.7c-.57-.51-1.41-.61-2.35-.2-.09.04-.19.09-.29.14-.24.12-.47.27-.69.44-1.62 1.23-2.87 3.58-2.9 5.63-.04 2.33 1.51 3.39 3.45 2.37 1.12-.59 2.13-1.74 2.79-3.05.21-.41.38-.84.51-1.27.18-.59.28-1.18.29-1.75.01-.64-.1-1.18-.3-1.61zm-.84 3.21c-.12.43-.29.86-.51 1.27-.48.88-1.16 1.63-1.92 2.03-1.4.74-2.52-.03-2.49-1.71.02-1.4.83-2.99 1.9-3.91.22-.19.45-.35.69-.48.1-.05.19-.09.29-.13.59-.23 1.12-.19 1.51.09.22.16.4.39.53.69.12.29.18.65.18 1.07-.02.34-.08.71-.18 1.08z'
      fill='url(#banner_svg__SVGID_22_)'
    />
    <linearGradient
      id='banner_svg__SVGID_23_'
      gradientUnits='userSpaceOnUse'
      x1={137.765}
      y1={94.813}
      x2={145.441}
      y2={94.813}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M146.18 110.77c-.96.5-1.84 1.43-2.49 2.52-.24.4-.45.82-.61 1.25-.3.76-.47 1.55-.48 2.3-.01.64.1 1.18.3 1.61.13.28.31.52.52.7.63.55 1.57.61 2.63.06.05-.03.11-.06.16-.09.34-.2.67-.45.98-.73 1.39-1.3 2.42-3.39 2.45-5.24.03-2.33-1.52-3.4-3.46-2.38zm1.03 6.35c-.3.33-.63.62-.98.83-.05.03-.11.06-.16.09-.7.37-1.33.36-1.78.05-.23-.16-.41-.39-.53-.69-.12-.3-.19-.66-.18-1.08.01-.54.13-1.1.34-1.65.17-.44.39-.86.66-1.24.44-.64.99-1.18 1.59-1.5 1.4-.74 2.52.03 2.5 1.72-.03 1.2-.62 2.53-1.46 3.47z'
      fill='url(#banner_svg__SVGID_23_)'
    />
    <linearGradient
      id='banner_svg__SVGID_24_'
      gradientUnits='userSpaceOnUse'
      x1={138.217}
      y1={135.838}
      x2={145.893}
      y2={135.838}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#f22aff' />
      <stop offset={1} stopColor='#6c00e9' />
    </linearGradient>
    <path
      d='M146.59 155.37a3.5 3.5 0 00-.72.29c-.08.04-.17.09-.25.14-1.06.64-1.99 1.78-2.6 3.05-.2.41-.36.84-.48 1.27-.15.54-.24 1.08-.25 1.6-.01.66.11 1.22.32 1.66.14.28.32.51.53.68.63.52 1.56.58 2.6.03 1.94-1.02 3.55-3.74 3.59-6.07.02-2.01-1.15-3.08-2.74-2.65zm-.84 7.57c-.68.36-1.29.36-1.74.08-.23-.15-.42-.37-.55-.66a2.61 2.61 0 01-.21-1.14c0-.3.05-.61.12-.92.1-.43.26-.87.47-1.27.43-.84 1.05-1.59 1.75-2.04.08-.05.17-.1.25-.15.25-.13.49-.22.72-.25 1.05-.18 1.8.59 1.77 1.97-.01 1.67-1.18 3.64-2.58 4.38z'
      fill='url(#banner_svg__SVGID_24_)'
    />
    <linearGradient
      id='banner_svg__SVGID_25_'
      gradientUnits='userSpaceOnUse'
      x1={102.688}
      y1={155.725}
      x2={110.363}
      y2={155.725}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#ff0007' />
      <stop offset={1} stopColor='#ffaaac' />
    </linearGradient>
    <path
      d='M116.34 196.33c-.05-.37-.15-.7-.29-.98-.55-1.1-1.74-1.44-3.13-.71s-2.61 2.33-3.2 4.03c-.15.43-.26.87-.32 1.3-.04.25-.06.49-.06.73-.04 2.33 1.51 3.39 3.45 2.37 1.94-1.02 3.55-3.74 3.59-6.07 0-.23-.01-.45-.04-.67zm-3.53 5.58c-1.4.74-2.52-.03-2.49-1.72v-.07c.01-.43.1-.87.25-1.31.42-1.26 1.32-2.47 2.34-3.01 1.03-.54 1.9-.27 2.29.57.13.29.21.65.21 1.07v.07c-.03 1.7-1.2 3.67-2.6 4.4z'
      fill='url(#banner_svg__SVGID_25_)'
    />
    <linearGradient
      id='banner_svg__SVGID_26_'
      gradientUnits='userSpaceOnUse'
      x1={102.69}
      y1={74.831}
      x2={110.365}
      y2={74.831}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#ff0007' />
      <stop offset={1} stopColor='#ffaaac' />
    </linearGradient>
    <path
      d='M114.37 105.69c-1.94 1.02-3.55 3.74-3.59 6.07 0 .28.01.53.05.77.06.36.16.68.31.95.56 1.05 1.73 1.36 3.09.65 1.36-.71 2.56-2.27 3.17-3.93.16-.43.27-.86.34-1.29.05-.28.07-.56.08-.84.04-2.33-1.51-3.4-3.45-2.38zm2.47 3.06c-.03.43-.12.87-.28 1.31-.43 1.23-1.31 2.38-2.31 2.9-1 .53-1.86.28-2.26-.51-.14-.28-.22-.63-.24-1.04v-.17c.03-1.68 1.19-3.65 2.59-4.39 1.4-.74 2.52.03 2.49 1.72.01.06.01.12.01.18z'
      fill='url(#banner_svg__SVGID_26_)'
    />
    <linearGradient
      id='banner_svg__SVGID_27_'
      gradientUnits='userSpaceOnUse'
      x1={1424.095}
      y1={161.073}
      x2={1441.209}
      y2={161.073}
      gradientTransform='translate(-1386.325)'
    >
      <stop offset={0} stopColor='#fd8d1f' />
      <stop offset={1} stopColor='#fd5c1f' />
    </linearGradient>
    <path
      d='M37.77 157.49l.01 16.18c0 .98 1.06 1.58 1.9 1.1l13.94-8.05c.78-.45 1.26-1.28 1.26-2.18v-15.96c0-1.04-1.13-1.69-2.03-1.17l-13.88 8c-.74.42-1.2 1.21-1.2 2.08z'
      fill='url(#banner_svg__SVGID_27_)'
    />
    <linearGradient
      id='banner_svg__SVGID_28_'
      gradientUnits='userSpaceOnUse'
      x1={1424.095}
      y1={189.593}
      x2={1441.209}
      y2={189.593}
      gradientTransform='translate(-1386.325)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M37.77 186.01l.01 16.18c0 .98 1.06 1.58 1.9 1.1l13.94-8.05c.78-.45 1.26-1.28 1.26-2.18V177.1c0-1.04-1.13-1.69-2.03-1.17l-13.88 8c-.74.42-1.2 1.21-1.2 2.08z'
      fill='url(#banner_svg__SVGID_28_)'
    />
    <linearGradient
      id='banner_svg__SVGID_29_'
      gradientUnits='userSpaceOnUse'
      x1={1424.095}
      y1={218.112}
      x2={1441.209}
      y2={218.112}
      gradientTransform='translate(-1386.325)'
    >
      <stop offset={0} stopColor='#ff0007' />
      <stop offset={1} stopColor='#ffaaac' />
    </linearGradient>
    <path
      d='M37.77 214.53l.01 16.18c0 .98 1.06 1.58 1.9 1.1l13.94-8.05c.78-.45 1.26-1.28 1.26-2.18V205.6c0-1.04-1.13-1.69-2.03-1.17l-13.88 8c-.74.44-1.2 1.23-1.2 2.1z'
      fill='url(#banner_svg__SVGID_29_)'
    />
    <linearGradient
      id='banner_svg__SVGID_30_'
      gradientUnits='userSpaceOnUse'
      x1={163.836}
      y1={118.822}
      x2={182.696}
      y2={118.822}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M165.95 85.16l14.3-8.26c1.09-.63 2.44.16 2.44 1.41v70.78c0 1.61-.86 3.09-2.25 3.89l-13.28 7.67c-1.48.86-3.33-.21-3.33-1.92v-69.9c.01-1.52.81-2.91 2.12-3.67z'
      fill='url(#banner_svg__SVGID_30_)'
    />
    <linearGradient
      id='banner_svg__SVGID_31_'
      gradientUnits='userSpaceOnUse'
      x1={101.774}
      y1={245.999}
      x2={172.758}
      y2={245.999}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_31_)' d='M101.77 268.06l70.99-40.88v-3.25l-70.99 40.97z' />
    <path
      d='M359.69 74.94c.42-.2.88-.29 1.36-.24.34.03.68.13 1 .32l1.73 1 52.39 30.25c1.69.97 2.73 2.78 2.73 4.73l.01 53.64v1.55c0 .72-.24 1.36-.62 1.87-.25.32-.56.6-.91.8l1.92-.98h.01c.23-.08.45-.2.65-.33l.03-.01c.81-.54 1.38-1.45 1.38-2.56l-.01-55.2c0-1.95-1.04-3.76-2.73-4.73l-53.71-31.01-.41-.23a2.51 2.51 0 00-1.75-.3h-.01l-.46.14h-.01l-.35.17-2.24 1.12z'
      fill='#cad8fc'
    />
    <path
      className='banner_svg__st2'
      d='M358.24 77.23v56.26c0 1.87 1 3.59 2.61 4.53l53.43 30.86c.94.54 1.98.52 2.84.13l.26-.13a3.045 3.045 0 001.53-2.67V111c0-1.95-1.04-3.75-2.73-4.73l-52.39-30.25-1.73-1c-.32-.19-.67-.29-1-.32-.48-.05-.94.03-1.36.24l-.02.01c-.83.39-1.44 1.23-1.44 2.28z'
    />
    <linearGradient
      id='banner_svg__SVGID_32_'
      gradientUnits='userSpaceOnUse'
      x1={594.608}
      y1={117.766}
      x2={616.674}
      y2={117.766}
      gradientTransform='matrix(-1 0 0 1 1008.01 0)'
    >
      <stop offset={0} stopColor='#e9efff' />
      <stop offset={1} stopColor='#d4e3ff' />
    </linearGradient>
    <path
      d='M413.4 113.14l-.01 20.86c0 1.26-1.36 2.04-2.45 1.41l-17.98-10.38a3.243 3.243 0 01-1.63-2.82v-20.58c0-1.34 1.45-2.18 2.61-1.51l17.9 10.32c.97.56 1.56 1.59 1.56 2.7z'
      fill='url(#banner_svg__SVGID_32_)'
    />
    <defs>
      <filter
        id='banner_svg__Adobe_OpacityMaskFilter'
        filterUnits='userSpaceOnUse'
        x={374.22}
        y={97.75}
        width={12.14}
        height={7.48}
      >
        <feFlood result='back' floodColor='#fff' floodOpacity={1} />
        <feBlend in='SourceGraphic' in2='back' />
      </filter>
    </defs>
    <mask maskUnits='userSpaceOnUse' x={374.22} y={97.75} width={12.14} height={7.48} id='banner_svg__SVGID_33_'>
      <g filter='url(#banner_svg__Adobe_OpacityMaskFilter)'>
        <defs>
          <filter
            id='banner_svg__Adobe_OpacityMaskFilter_1_'
            filterUnits='userSpaceOnUse'
            x={374.22}
            y={97.75}
            width={12.14}
            height={7.48}
          >
            <feFlood result='back' floodColor='#fff' floodOpacity={1} />
            <feBlend in='SourceGraphic' in2='back' />
          </filter>
        </defs>
        <linearGradient
          id='banner_svg__SVGID_34_'
          gradientUnits='userSpaceOnUse'
          x1={621.648}
          y1={101.49}
          x2={633.793}
          y2={101.49}
          gradientTransform='matrix(-1 0 0 1 1008.01 0)'
        >
          <stop offset={0} stopColor='#666' />
          <stop offset={0.056} stopColor='#737373' />
          <stop offset={0.284} stopColor='#a5a5a5' />
          <stop offset={0.5} stopColor='#ccc' />
          <stop offset={0.698} stopColor='#e8e8e8' />
          <stop offset={0.87} stopColor='#f9f9f9' />
          <stop offset={0.999} stopColor='#fff' />
        </linearGradient>
        <path
          d='M385.81 105.23c.19 0 .38-.1.48-.28.15-.27.06-.61-.2-.76l-11.03-6.37a.562.562 0 00-.76.2c-.15.27-.06.61.2.76l11.03 6.37c.09.06.18.08.28.08z'
          mask='url(#banner_svg__SVGID_33_)'
          fill='url(#banner_svg__SVGID_34_)'
        />
      </g>
    </mask>
    <linearGradient
      id='banner_svg__SVGID_35_'
      gradientUnits='userSpaceOnUse'
      x1={621.648}
      y1={101.49}
      x2={633.793}
      y2={101.49}
      gradientTransform='matrix(-1 0 0 1 1008.01 0)'
    >
      <stop offset={0} stopColor='#e9f2ff' />
      <stop offset={0.277} stopColor='#c7dbff' />
      <stop offset={0.562} stopColor='#abc8ff' />
      <stop offset={0.812} stopColor='#9abdff' />
      <stop offset={0.999} stopColor='#94b9ff' />
    </linearGradient>
    <path
      d='M385.81 105.23c.19 0 .38-.1.48-.28.15-.27.06-.61-.2-.76l-11.03-6.37a.562.562 0 00-.76.2c-.15.27-.06.61.2.76l11.03 6.37c.09.06.18.08.28.08z'
      fill='url(#banner_svg__SVGID_35_)'
    />
    <defs>
      <filter
        id='banner_svg__Adobe_OpacityMaskFilter_2_'
        filterUnits='userSpaceOnUse'
        x={368.7}
        y={100.93}
        width={17.66}
        height={10.66}
      >
        <feFlood result='back' floodColor='#fff' floodOpacity={1} />
        <feBlend in='SourceGraphic' in2='back' />
      </filter>
    </defs>
    <mask maskUnits='userSpaceOnUse' x={368.7} y={100.93} width={17.66} height={10.66} id='banner_svg__SVGID_36_'>
      <g filter='url(#banner_svg__Adobe_OpacityMaskFilter_2_)'>
        <defs>
          <filter
            id='banner_svg__Adobe_OpacityMaskFilter_3_'
            filterUnits='userSpaceOnUse'
            x={368.7}
            y={100.93}
            width={17.66}
            height={10.66}
          >
            <feFlood result='back' floodColor='#fff' floodOpacity={1} />
            <feBlend in='SourceGraphic' in2='back' />
          </filter>
        </defs>
        <linearGradient
          id='banner_svg__SVGID_37_'
          gradientUnits='userSpaceOnUse'
          x1={621.648}
          y1={106.263}
          x2={639.309}
          y2={106.263}
          gradientTransform='matrix(-1 0 0 1 1008.01 0)'
        >
          <stop offset={0} stopColor='#666' />
          <stop offset={0.056} stopColor='#737373' />
          <stop offset={0.284} stopColor='#a5a5a5' />
          <stop offset={0.5} stopColor='#ccc' />
          <stop offset={0.698} stopColor='#e8e8e8' />
          <stop offset={0.87} stopColor='#f9f9f9' />
          <stop offset={0.999} stopColor='#fff' />
        </linearGradient>
        <path
          d='M385.81 111.59c.19 0 .38-.1.48-.28.15-.27.06-.61-.2-.76L369.54 101a.562.562 0 00-.76.2c-.15.27-.06.61.2.76l16.55 9.55c.09.06.18.08.28.08z'
          mask='url(#banner_svg__SVGID_36_)'
          fill='url(#banner_svg__SVGID_37_)'
        />
      </g>
    </mask>
    <linearGradient
      id='banner_svg__SVGID_38_'
      gradientUnits='userSpaceOnUse'
      x1={621.648}
      y1={106.263}
      x2={639.309}
      y2={106.263}
      gradientTransform='matrix(-1 0 0 1 1008.01 0)'
    >
      <stop offset={0} stopColor='#e9f2ff' />
      <stop offset={0.277} stopColor='#c7dbff' />
      <stop offset={0.562} stopColor='#abc8ff' />
      <stop offset={0.812} stopColor='#9abdff' />
      <stop offset={0.999} stopColor='#94b9ff' />
    </linearGradient>
    <path
      d='M385.81 111.59c.19 0 .38-.1.48-.28.15-.27.06-.61-.2-.76L369.54 101a.562.562 0 00-.76.2c-.15.27-.06.61.2.76l16.55 9.55c.09.06.18.08.28.08z'
      fill='url(#banner_svg__SVGID_38_)'
    />
    <defs>
      <filter
        id='banner_svg__Adobe_OpacityMaskFilter_4_'
        filterUnits='userSpaceOnUse'
        x={363.19}
        y={104.12}
        width={23.19}
        height={13.84}
      >
        <feFlood result='back' floodColor='#fff' floodOpacity={1} />
        <feBlend in='SourceGraphic' in2='back' />
      </filter>
    </defs>
    <mask maskUnits='userSpaceOnUse' x={363.19} y={104.12} width={23.19} height={13.84} id='banner_svg__SVGID_39_'>
      <g filter='url(#banner_svg__Adobe_OpacityMaskFilter_4_)'>
        <defs>
          <filter
            id='banner_svg__Adobe_OpacityMaskFilter_5_'
            filterUnits='userSpaceOnUse'
            x={363.19}
            y={104.12}
            width={23.19}
            height={13.84}
          >
            <feFlood result='back' floodColor='#fff' floodOpacity={1} />
            <feBlend in='SourceGraphic' in2='back' />
          </filter>
        </defs>
        <linearGradient
          id='banner_svg__SVGID_40_'
          gradientUnits='userSpaceOnUse'
          x1={621.635}
          y1={111.042}
          x2={644.826}
          y2={111.042}
          gradientTransform='matrix(-1 0 0 1 1008.01 0)'
        >
          <stop offset={0} stopColor='#666' />
          <stop offset={0.056} stopColor='#737373' />
          <stop offset={0.284} stopColor='#a5a5a5' />
          <stop offset={0.5} stopColor='#ccc' />
          <stop offset={0.698} stopColor='#e8e8e8' />
          <stop offset={0.87} stopColor='#f9f9f9' />
          <stop offset={0.999} stopColor='#fff' />
        </linearGradient>
        <path
          d='M385.82 117.96c.19 0 .38-.1.48-.28.15-.27.06-.61-.2-.76l-22.08-12.73a.562.562 0 00-.76.2c-.15.27-.06.61.2.76l22.08 12.73c.09.06.18.08.28.08z'
          mask='url(#banner_svg__SVGID_39_)'
          fill='url(#banner_svg__SVGID_40_)'
        />
      </g>
    </mask>
    <linearGradient
      id='banner_svg__SVGID_41_'
      gradientUnits='userSpaceOnUse'
      x1={621.635}
      y1={111.042}
      x2={644.826}
      y2={111.042}
      gradientTransform='matrix(-1 0 0 1 1008.01 0)'
    >
      <stop offset={0} stopColor='#e9f2ff' />
      <stop offset={0.277} stopColor='#c7dbff' />
      <stop offset={0.562} stopColor='#abc8ff' />
      <stop offset={0.812} stopColor='#9abdff' />
      <stop offset={0.999} stopColor='#94b9ff' />
    </linearGradient>
    <path
      d='M385.82 117.96c.19 0 .38-.1.48-.28.15-.27.06-.61-.2-.76l-22.08-12.73a.562.562 0 00-.76.2c-.15.27-.06.61.2.76l22.08 12.73c.09.06.18.08.28.08z'
      fill='url(#banner_svg__SVGID_41_)'
    />
    <linearGradient
      id='banner_svg__SVGID_42_'
      gradientUnits='userSpaceOnUse'
      x1={594.615}
      y1={137.942}
      x2={644.268}
      y2={137.942}
      gradientTransform='matrix(-1 0 0 1 1008.01 0)'
    >
      <stop offset={0} stopColor='#fd8d1f' />
      <stop offset={1} stopColor='#fd5c1f' />
    </linearGradient>
    <path
      d='M413.4 144.85v13.59c0 1.57-1.7 2.56-3.06 1.77l-44.86-25.88a3.46 3.46 0 01-1.73-2.99l.01-14.34c0-1.24 1.35-2.02 2.42-1.4l45.52 26.29a3.45 3.45 0 011.7 2.96z'
      fill='url(#banner_svg__SVGID_42_)'
    />
    <path
      className='banner_svg__st46'
      d='M283.41 122.05c0 1.95-1.04 3.76-2.73 4.73l-48.46 27.99c-1.64.95-3.47.93-4.99.23l-.04-.01a5.83 5.83 0 01-.69-.39c-.46-.3-.86-.66-1.21-1.08-.67-.8-1.12-1.82-1.23-2.96a8.7 8.7 0 01-.02-.52v-4.83l-.01-109.92c0-1.95 1.04-3.76 2.73-4.73l44.67-25.78 2.17-1.25 1.34-.78.29-.17c.46-.27.94-.46 1.42-.57.94-.24 1.9-.21 2.78.04.2.05.4.12.59.2 1.95.78 3.42 2.67 3.42 5.06l-.03 114.74z'
    />
    <linearGradient
      id='banner_svg__SVGID_43_'
      gradientUnits='userSpaceOnUse'
      x1={253.77}
      y1={132.057}
      x2={261.647}
      y2={132.057}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M261.62 129.83c.23 2.23-1.33 5.04-3.5 6.27-2.16 1.23-4.1.42-4.34-1.82-.23-2.23 1.33-5.04 3.5-6.27s4.11-.41 4.34 1.82z'
      fill='url(#banner_svg__SVGID_43_)'
    />
    <path
      className='banner_svg__st2'
      d='M279.15 121.32c.01.88-.47 1.7-1.23 2.14l-15.91 9.19c.48-1.16.7-2.35.6-3.44-.3-2.83-2.75-3.86-5.49-2.3s-4.72 5.11-4.43 7.94c.12 1.13.57 1.96 1.26 2.46l-22.01 12.71c-1.64.94-3.69-.23-3.69-2.13V36.79c0-1.37.72-2.65 1.9-3.34L272.7 8.27c2.58-1.53 5.85.32 5.86 3.32l.59 109.73z'
    />
    <path
      className='banner_svg__st2'
      d='M258.4 132.78l-1.01.57c-.26.15-.49.05-.52-.22l-.11-1.04c-.03-.27.16-.61.42-.75l1.01-.57c.26-.15.49-.05.52.22l.11 1.04c.02.26-.16.6-.42.75z'
    />
    <path
      className='banner_svg__st46'
      d='M240.98 26.68l2.48 1.55c1.08.68 2.45.7 3.56.06l13.35-7.71c1.19-.69 2.17-1.7 2.82-2.91l3.25-6.05-25.46 15.06z'
    />
    <linearGradient
      id='banner_svg__SVGID_44_'
      gradientUnits='userSpaceOnUse'
      x1={218.48}
      y1={77.491}
      x2={279.408}
      y2={77.491}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M279.41 2.03c-.89-.25-1.85-.28-2.78-.04-.48.12-.96.31-1.42.57l-.29.17-1.34.78-2.17 1.25-44.67 25.78a5.455 5.455 0 00-2.73 4.73l.01 109.92v4.83c0 .18.01.36.02.52.11 1.15.56 2.17 1.23 2.96a5.646 5.646 0 001.9 1.47l-4.61-1.49-.56-.18a5.99 5.99 0 01-1.04-.53 5.388 5.388 0 01-2.46-4.57v-4.83l-.01-109.92c0-1.95 1.04-3.76 2.73-4.73l44.67-25.78 3.5-2.03.29-.17a5.36 5.36 0 014.44-.46l5.29 1.75z'
      fill='url(#banner_svg__SVGID_44_)'
    />
    <path
      className='banner_svg__st46'
      d='M220.69 58.64c.31.18.6.19.81.07h.02l.04-.03c.09-.06.16-.16.21-.27.03-.07.05-.15.06-.24.06-.59-.35-1.32-.92-1.65-.18-.1-.35-.15-.5-.15-.11 0-.2.02-.29.07-.19.09-.32.28-.35.56-.06.58.35 1.32.92 1.64z'
    />
    <path
      className='banner_svg__st2'
      d='M220.12 56.43c.09-.04.18-.06.29-.06.15 0 .32.05.5.15.57.32.98 1.06.92 1.65-.01.09-.03.17-.06.24-.04.12-.12.21-.21.27l.53-.36.06-.04c.14-.1.24-.27.26-.51.06-.59-.35-1.32-.92-1.65-.31-.18-.6-.19-.82-.07l-.05.04-.5.34z'
    />
    <path
      className='banner_svg__st46'
      d='M220.69 68.54c.31.18.6.19.81.07h.02l.04-.03c.09-.06.16-.16.21-.27.03-.07.05-.15.06-.24.06-.59-.35-1.32-.92-1.65-.18-.1-.35-.15-.5-.15-.11 0-.2.02-.29.07-.19.09-.32.28-.35.56-.06.58.35 1.32.92 1.64z'
    />
    <path
      className='banner_svg__st2'
      d='M220.12 66.33c.09-.04.18-.06.29-.06.15 0 .32.05.5.15.57.32.98 1.06.92 1.65-.01.09-.03.17-.06.24-.04.12-.12.21-.21.27l.53-.36.06-.04c.14-.1.24-.27.26-.51.06-.59-.35-1.32-.92-1.65-.31-.18-.6-.19-.82-.07l-.05.05-.5.33z'
    />
    <linearGradient
      id='banner_svg__SVGID_45_'
      gradientUnits='userSpaceOnUse'
      x1={220.68}
      y1={45.692}
      x2={221.857}
      y2={45.692}
    >
      <stop offset={0} stopColor='#ff0007' />
      <stop offset={1} stopColor='#ffaaac' />
    </linearGradient>
    <path
      d='M221.46 43.06a.52.52 0 00-.78.45v3.97c0 .35.19.67.49.84.31.18.69-.04.69-.4v-4.19c0-.27-.15-.52-.4-.67z'
      fill='url(#banner_svg__SVGID_45_)'
    />
    <linearGradient
      id='banner_svg__SVGID_46_'
      gradientUnits='userSpaceOnUse'
      x1={238.695}
      y1={109.558}
      x2={268.727}
      y2={109.558}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M238.69 115.65v4.34c0 1.19 1.29 1.94 2.33 1.34l26.31-15.19c.86-.5 1.4-1.42 1.4-2.42V98.8c0-.95-1.03-1.54-1.85-1.07l-26.76 15.45c-.88.51-1.43 1.46-1.43 2.47z'
      fill='url(#banner_svg__SVGID_46_)'
    />
    <linearGradient
      id='banner_svg__SVGID_47_'
      gradientUnits='userSpaceOnUse'
      x1={246.109}
      y1={104.127}
      x2={271.436}
      y2={104.127}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#aac9ff' />
      <stop offset={1} stopColor='#e9f1ff' />
    </linearGradient>
    <path
      d='M265.03 62.7c-.12 7.69-5.43 16.66-11.84 20.02-6.41 3.37-11.51-.14-11.39-7.83.12-7.69 5.43-16.66 11.84-20.02 6.42-3.36 11.52.14 11.39 7.83z'
      fill='url(#banner_svg__SVGID_47_)'
    />
    <linearGradient
      id='banner_svg__SVGID_48_'
      gradientUnits='userSpaceOnUse'
      x1={259.252}
      y1={103.996}
      x2={259.31}
      y2={103.996}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M254.11 53.09c.02-.01.04-.02.05-.02-.02 0-.03.01-.05.02zm-.5 30.68c.02-.01.04-.02.05-.03-.01.01-.03.02-.05.03z'
      fill='url(#banner_svg__SVGID_48_)'
    />
    <linearGradient
      id='banner_svg__SVGID_49_'
      gradientUnits='userSpaceOnUse'
      x1={244.237}
      y1={103.996}
      x2={273.233}
      y2={103.996}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M263.4 52.78c-.11-.09-.22-.17-.34-.25l-.09-.06c-2.33-1.6-5.43-1.6-8.77-.01-.14.06-.27.13-.41.2l-.01.01c-.04.02-.09.04-.13.07-3.55 1.87-6.92 5.28-9.48 9.61-.03.05-.06.1-.09.16-.12.2-.24.41-.35.61-2.29 4.12-3.57 8.54-3.64 12.55-.06 3.88 1.02 6.94 3.08 8.73.11.09.21.18.32.27.1.08.21.15.31.23 2.46 1.69 5.78 1.6 9.33-.27.04-.02.09-.04.13-.07l.01-.01c.14-.07.27-.15.41-.23 3.35-1.92 6.5-5.2 8.93-9.3.11-.19.22-.37.33-.56.12-.2.23-.41.34-.62 2.15-4 3.35-8.26 3.41-12.14.06-4.01-1.1-7.15-3.29-8.92zm-18.89 9.8c1.91-3.22 4.28-5.92 6.83-7.81-1.15 1.38-2.21 3.24-3.1 5.49-.29.74-.56 1.5-.81 2.28-1.08.17-2.06.18-2.92.04zm-.36.62c.02 0 .04.01.05.01.91.16 1.93.15 3.04-.02-.85 2.93-1.34 6.08-1.42 9.16l-5.23 2.75c.12-3.81 1.38-8 3.56-11.9zm-.56 20.65c-1.95-1.68-3.01-4.53-3.01-8.15l5.23-2.75c-.02 2.88.33 5.44 1.02 7.47-1.07.97-2.06 2-2.96 3.08-.09.12-.19.23-.28.35zm.57.44c-.08-.06-.16-.11-.24-.17.9-1.11 1.94-2.2 3.08-3.23.25.67.55 1.27.88 1.8.84 1.34 1.85 2.11 2.98 2.3-2.55.79-4.87.56-6.7-.7zm8.96-.26c-2.38 1.08-4.43-.39-5.64-3.57 1.74-1.51 3.7-2.87 5.77-3.96l-.13 7.53zm.13-8.12c-2.09 1.1-4.12 2.5-5.94 4.09-.66-1.93-1.02-4.42-1-7.31l7.06-3.71-.12 6.93zm.12-7.52l-7.06 3.71c.08-3.09.59-6.2 1.4-8.98 1.77-.33 3.74-1.04 5.78-2.11l-.12 7.38zm.13-7.98c-2.01 1.05-3.91 1.73-5.59 2.05 1.35-4.29 3.41-7.75 5.71-9.12l-.12 7.07zm12.69 1.25l-4.77 2.51c.02-3.11-.39-5.85-1.19-7.95.96-.9 1.87-1.84 2.68-2.83a.18.18 0 00.05-.07c2.1 1.65 3.23 4.58 3.23 8.34zm-3.57-8.59c-.77.92-1.63 1.83-2.57 2.7a9.87 9.87 0 00-.69-1.34c-.78-1.24-1.71-2-2.74-2.25 2.26-.55 4.33-.26 6 .89zm-8.51.02c.02-.01.04-.02.05-.02 2.24-.99 4.18.29 5.41 3.13a30.979 30.979 0 01-5.57 3.95l.11-7.06zm-.13 7.65c2.04-1.12 4-2.51 5.77-4.09.76 1.99 1.19 4.65 1.17 7.78l-7.06 3.71.12-7.4zm-.12 7.98l7.06-3.71c-.07 2.98-.55 5.96-1.31 8.67-1.78.26-3.78.92-5.86 1.97l.11-6.93zm-.19 15.02c-.02.01-.04.02-.05.03l.12-7.52c2.06-1.03 3.99-1.66 5.68-1.91-1.33 4.4-3.42 7.98-5.75 9.4zm8.59-8.96c-1.73 2.93-3.85 5.42-6.14 7.27 1.06-1.35 2.03-3.1 2.86-5.19.33-.83.63-1.69.9-2.58.97-.11 1.85-.08 2.63.08-.08.13-.16.28-.25.42zm.6-1.05c-.09-.02-.18-.04-.28-.05-.76-.13-1.6-.15-2.5-.05.8-2.84 1.26-5.89 1.34-8.87l4.77-2.51c-.12 3.68-1.29 7.71-3.33 11.48z'
      fill='url(#banner_svg__SVGID_49_)'
    />
    <linearGradient
      id='banner_svg__SVGID_50_'
      gradientUnits='userSpaceOnUse'
      x1={240.833}
      y1={104.001}
      x2={276.956}
      y2={104.001}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M252.17 47.77l-13.55 16.31c.11.09.19.2.26.34l13.44-16.18a1.3 1.3 0 01-.15-.47zm3.43-1.81c-.04.21-.09.43-.17.64l12.77 2.16c.08-.21.19-.42.3-.62l-12.9-2.18zm14.16 5.08l-.3 18.24c.04-.03.08-.05.13-.07.12-.06.24-.11.36-.14l.3-18.39c-.16.14-.32.27-.49.36zm-1.79 22.02l-13.2 15.89c.07.14.12.3.14.49l13.33-16.04c-.11-.09-.2-.2-.27-.34zm-29.24 15.37c-.06.21-.15.43-.25.63l12.98 2.19c.03-.21.09-.43.16-.65l-12.89-2.17zm-1.48-20.17c-.05.02-.09.05-.14.06l-.3 18.28c.11-.08.23-.16.34-.22.05-.03.1-.05.14-.07l.3-18.29c-.11.1-.22.17-.34.24z'
      fill='url(#banner_svg__SVGID_50_)'
    />
    <linearGradient
      id='banner_svg__SVGID_51_'
      gradientUnits='userSpaceOnUse'
      x1={242.6}
      y1={95.718}
      x2={246.301}
      y2={95.718}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path d='M242.11 66.46l-.26.63-3.11-.6c.09-.21.16-.42.21-.64l3.16.61z' fill='url(#banner_svg__SVGID_51_)' />
    <linearGradient
      id='banner_svg__SVGID_52_'
      gradientUnits='userSpaceOnUse'
      x1={271.046}
      y1={95.904}
      x2={274.9}
      y2={95.904}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path d='M268.37 51.06l-3.32 4.08-.24-.37 3.31-4.06c.06.14.15.26.25.35z' fill='url(#banner_svg__SVGID_52_)' />
    <linearGradient
      id='banner_svg__SVGID_53_'
      gradientUnits='userSpaceOnUse'
      x1={271.046}
      y1={112.191}
      x2={275.03}
      y2={112.191}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path d='M264.8 70.15l3.37.65c-.1.21-.18.42-.24.63l-3.38-.66.25-.62z' fill='url(#banner_svg__SVGID_53_)' />
    <linearGradient
      id='banner_svg__SVGID_54_'
      gradientUnits='userSpaceOnUse'
      x1={242.65}
      y1={112.187}
      x2={246.653}
      y2={112.187}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path d='M242.17 82.53l-3.45 4.23c-.07-.14-.15-.26-.26-.35l3.46-4.25.25.37z' fill='url(#banner_svg__SVGID_54_)' />
    <linearGradient
      id='banner_svg__SVGID_55_'
      gradientUnits='userSpaceOnUse'
      x1={239.073}
      y1={93.927}
      x2={242.89}
      y2={93.927}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M238.88 64.42c-.07-.14-.16-.26-.26-.34-.31-.27-.78-.3-1.3-.02-.97.51-1.77 1.86-1.78 3.02-.02 1.1.68 1.64 1.58 1.24.04-.02.09-.04.14-.06.12-.06.24-.14.35-.23.48-.37.89-.93 1.15-1.54.09-.21.16-.42.21-.64.05-.21.07-.41.08-.61-.01-.33-.07-.6-.17-.82zm-.36 1.34c-.03.21-.1.43-.19.64-.17.4-.43.76-.73 1.03-.11.1-.23.18-.35.24-.05.02-.09.04-.14.06-.63.25-1.12-.13-1.11-.92.01-.84.59-1.82 1.29-2.18.34-.18.65-.18.87-.03.11.07.21.19.27.33.07.15.1.34.1.55.02.1.01.19-.01.28z'
      fill='url(#banner_svg__SVGID_55_)'
    />
    <linearGradient
      id='banner_svg__SVGID_56_'
      gradientUnits='userSpaceOnUse'
      x1={239.298}
      y1={114.329}
      x2={243.115}
      y2={114.329}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#fd8d1f' />
      <stop offset={1} stopColor='#fd5c1f' />
    </linearGradient>
    <path
      d='M238.73 86.76c-.07-.14-.15-.26-.26-.35-.29-.25-.7-.3-1.17-.1-.05.02-.09.04-.14.07-.12.06-.23.14-.34.22-.81.61-1.42 1.78-1.44 2.8-.02 1.16.75 1.69 1.72 1.18.56-.29 1.06-.86 1.39-1.52.1-.2.19-.42.25-.63.09-.29.14-.59.15-.87-.01-.31-.06-.58-.16-.8zm-.42 1.6c-.06.22-.15.43-.25.63-.24.44-.58.81-.96 1.01-.7.37-1.25-.02-1.24-.85.01-.69.41-1.49.95-1.95.11-.09.22-.17.34-.24.05-.03.1-.05.14-.06.29-.12.56-.09.75.04.11.08.2.19.26.34.06.15.09.33.09.53 0 .18-.03.37-.08.55z'
      fill='url(#banner_svg__SVGID_56_)'
    />
    <linearGradient
      id='banner_svg__SVGID_57_'
      gradientUnits='userSpaceOnUse'
      x1={274.43}
      y1={93.802}
      x2={278.248}
      y2={93.802}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M269.75 46.89c-.48.25-.92.71-1.24 1.25-.12.2-.22.41-.3.62-.15.38-.24.77-.24 1.14-.01.32.05.59.15.8.07.14.15.26.26.35.31.27.78.31 1.31.03.03-.01.05-.03.08-.05.17-.1.33-.22.49-.37.69-.64 1.2-1.69 1.22-2.61 0-1.14-.77-1.67-1.73-1.16zm.51 3.16c-.15.17-.31.31-.49.41-.03.02-.05.03-.08.05-.35.18-.66.18-.89.03a.757.757 0 01-.26-.34c-.06-.15-.09-.33-.09-.54 0-.27.07-.55.17-.82.08-.22.19-.43.33-.62.22-.32.49-.59.79-.74.7-.37 1.26.02 1.24.85-.01.59-.3 1.25-.72 1.72z'
      fill='url(#banner_svg__SVGID_57_)'
    />
    <linearGradient
      id='banner_svg__SVGID_58_'
      gradientUnits='userSpaceOnUse'
      x1={274.655}
      y1={114.204}
      x2={278.472}
      y2={114.204}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#fd8d1f' />
      <stop offset={1} stopColor='#fd5c1f' />
    </linearGradient>
    <path
      d='M269.95 69.07c-.12.03-.24.08-.36.14-.04.02-.08.05-.13.07-.53.32-.99.88-1.3 1.52-.1.21-.18.42-.24.63-.08.27-.12.54-.12.8-.01.33.05.61.16.83.07.14.16.25.26.34.31.26.77.29 1.29.01.97-.51 1.77-1.86 1.78-3.02.03-1-.55-1.53-1.34-1.32zm-.42 3.76c-.34.18-.64.18-.86.04a.641.641 0 01-.27-.33c-.07-.15-.11-.34-.1-.57 0-.15.02-.3.06-.46.05-.22.13-.43.23-.63.21-.42.52-.79.87-1.02.04-.03.08-.05.13-.07.12-.07.25-.11.36-.13.52-.09.89.29.88.98-.02.85-.6 1.83-1.3 2.19z'
      fill='url(#banner_svg__SVGID_58_)'
    />
    <linearGradient
      id='banner_svg__SVGID_59_'
      gradientUnits='userSpaceOnUse'
      x1={256.986}
      y1={124.094}
      x2={260.803}
      y2={124.094}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#ff0007' />
      <stop offset={1} stopColor='#ffaaac' />
    </linearGradient>
    <path
      d='M254.91 89.44c-.02-.19-.07-.35-.14-.49-.27-.55-.86-.72-1.55-.35-.69.36-1.3 1.16-1.59 2.01-.07.21-.13.43-.16.65-.02.12-.03.24-.03.37-.02 1.16.75 1.69 1.72 1.18s1.77-1.86 1.78-3.02c-.01-.13-.02-.24-.03-.35zm-1.76 2.78c-.7.37-1.25-.02-1.24-.85v-.03c.01-.21.05-.43.12-.65.21-.63.65-1.23 1.17-1.49s.95-.13 1.14.28c.07.14.1.32.1.53v.03c-.01.83-.59 1.81-1.29 2.18z'
      fill='url(#banner_svg__SVGID_59_)'
    />
    <linearGradient
      id='banner_svg__SVGID_60_'
      gradientUnits='userSpaceOnUse'
      x1={256.986}
      y1={83.864}
      x2={260.803}
      y2={83.864}
      gradientTransform='matrix(.9172 -.4816 -.0178 1.0996 17.925 78.93)'
    >
      <stop offset={0} stopColor='#ff0007' />
      <stop offset={1} stopColor='#ffaaac' />
    </linearGradient>
    <path
      d='M253.93 44.36c-.97.51-1.77 1.86-1.78 3.02 0 .14.01.27.03.38.03.18.08.34.15.47.28.52.86.68 1.54.32.68-.36 1.27-1.13 1.57-1.96.08-.21.14-.43.17-.64.02-.14.04-.28.04-.42.01-1.14-.76-1.67-1.72-1.17zm1.22 1.53c-.01.21-.06.43-.14.65-.21.61-.65 1.18-1.15 1.44-.5.26-.92.14-1.12-.25-.07-.14-.11-.31-.12-.52v-.09c.01-.84.59-1.82 1.29-2.18.7-.37 1.25.02 1.24.85.01.04 0 .07 0 .1z'
      fill='url(#banner_svg__SVGID_60_)'
    />
    <linearGradient
      id='banner_svg__SVGID_61_'
      gradientUnits='userSpaceOnUse'
      x1={241.868}
      y1={228.492}
      x2={433.942}
      y2={228.492}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M433.94 204.68v5.09c.02 1.55-.73 3.1-2.26 3.99l-79.27 45.73a13.093 13.093 0 01-13.07 0l-95.47-55.12a3.976 3.976 0 01-2.01-3.47v-5.16c0 .92.31 1.84.93 2.57.29.35.65.65 1.07.9l2.59 1.5 92.88 53.63c4.04 2.34 9.03 2.34 13.07.01l77.17-44.53 2.1-1.21a4.5 4.5 0 001.46-1.34c.54-.77.81-1.68.81-2.59z'
      fill='url(#banner_svg__SVGID_61_)'
    />
    <path
      className='banner_svg__st2'
      d='M433.94 204.61v.07c0 .91-.27 1.81-.8 2.58a4.5 4.5 0 01-1.46 1.34l-2.1 1.21-6.49 3.74-70.68 40.78a13.069 13.069 0 01-13.07-.01l-92.88-53.63-2.59-1.5c-.42-.25-.78-.55-1.07-.9-.62-.73-.93-1.65-.93-2.57v-.01c0-1.35.67-2.69 2.01-3.47l71.14-41.07 10.84-6.26a9.174 9.174 0 019.19 0l96.64 55.83c1.48.89 2.23 2.38 2.25 3.87z'
    />
    <linearGradient
      id='banner_svg__SVGID_62_'
      gradientUnits='userSpaceOnUse'
      x1={315.012}
      y1={178.634}
      x2={433.942}
      y2={178.634}
    >
      <stop offset={0} stopColor='#e9f1ff' />
      <stop offset={1} stopColor='#aac9ff' />
    </linearGradient>
    <path
      d='M433.94 204.61v.07c0 .91-.27 1.81-.8 2.58a4.5 4.5 0 01-1.46 1.34l-2.1 1.21-6.49 3.74-108.08-62.35 10.84-6.26a9.174 9.174 0 019.19 0l96.64 55.83c1.49.86 2.24 2.35 2.26 3.84z'
      fill='url(#banner_svg__SVGID_62_)'
    />
    <linearGradient
      id='banner_svg__SVGID_63_'
      gradientUnits='userSpaceOnUse'
      x1={401.467}
      y1={195.185}
      x2={407.067}
      y2={195.185}
    >
      <stop offset={0} stopColor='#fd8d1f' />
      <stop offset={1} stopColor='#fd5c1f' />
    </linearGradient>
    <path
      d='M406.87 195.7c-.56.76-2.19 1.14-3.63.85-1.44-.29-2.15-1.13-1.58-1.89.56-.76 2.19-1.14 3.63-.85 1.44.29 2.15 1.14 1.58 1.89z'
      fill='url(#banner_svg__SVGID_63_)'
    />
    <linearGradient
      id='banner_svg__SVGID_64_'
      gradientUnits='userSpaceOnUse'
      x1={409.793}
      y1={199.315}
      x2={415.394}
      y2={199.315}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M415.2 199.83c-.56.76-2.19 1.14-3.63.85-1.44-.29-2.15-1.13-1.58-1.89.56-.76 2.19-1.14 3.63-.85 1.44.29 2.14 1.14 1.58 1.89z'
      fill='url(#banner_svg__SVGID_64_)'
    />
    <linearGradient
      id='banner_svg__SVGID_65_'
      gradientUnits='userSpaceOnUse'
      x1={417.467}
      y1={203.51}
      x2={423.067}
      y2={203.51}
    >
      <stop offset={0} stopColor='#ff0007' />
      <stop offset={1} stopColor='#ffaaac' />
    </linearGradient>
    <path
      d='M422.87 204.03c-.56.76-2.19 1.14-3.63.85-1.44-.29-2.15-1.13-1.58-1.89.56-.76 2.19-1.14 3.63-.85 1.44.29 2.15 1.13 1.58 1.89z'
      fill='url(#banner_svg__SVGID_65_)'
    />
    <defs>
      <filter
        id='banner_svg__Adobe_OpacityMaskFilter_6_'
        filterUnits='userSpaceOnUse'
        x={298.55}
        y={153.88}
        width={68.23}
        height={74.42}
      >
        <feFlood result='back' floodColor='#fff' floodOpacity={1} />
        <feBlend in='SourceGraphic' in2='back' />
      </filter>
    </defs>
    <mask maskUnits='userSpaceOnUse' x={298.55} y={153.88} width={68.23} height={74.42} id='banner_svg__SVGID_66_'>
      <g filter='url(#banner_svg__Adobe_OpacityMaskFilter_6_)'>
        <defs>
          <filter
            id='banner_svg__Adobe_OpacityMaskFilter_7_'
            filterUnits='userSpaceOnUse'
            x={298.55}
            y={153.88}
            width={68.23}
            height={74.42}
          >
            <feFlood result='back' floodColor='#fff' floodOpacity={1} />
            <feBlend in='SourceGraphic' in2='back' />
          </filter>
        </defs>
        <linearGradient
          id='banner_svg__SVGID_67_'
          gradientUnits='userSpaceOnUse'
          x1={637.66}
          y1={191.086}
          x2={705.885}
          y2={191.086}
          gradientTransform='matrix(-1 0 0 1 1004.435 0)'
        >
          <stop offset={0} stopColor='#666' />
          <stop offset={0.056} stopColor='#737373' />
          <stop offset={0.284} stopColor='#a5a5a5' />
          <stop offset={0.5} stopColor='#ccc' />
          <stop offset={0.698} stopColor='#e8e8e8' />
          <stop offset={0.87} stopColor='#f9f9f9' />
          <stop offset={0.999} stopColor='#fff' />
        </linearGradient>
        <path
          d='M366.52 228.3c.26-4.84 1.27-29.15-3.8-32.07-.71-.41-1.47-.49-2.22-.24-2.52.84-4.45 5.34-6.7 10.56-1.79 4.17-4.02 9.37-5.93 10-.3.1-.56.06-.87-.11-2.7-1.56-3.04-13.63-3.31-23.33-.4-14.23-.88-23.01-4.27-24.97-.7-.41-1.45-.47-2.17-.17-2.69 1.1-4.45 6.93-7.1 16.37-2.06 7.34-4.63 16.48-7.35 17.59-.25.1-.61.18-1.15-.13-3.67-2.12-3.43-14.83-3.23-25.04.24-12.71.22-20.6-3.09-22.52-.91-.52-1.67-.36-2.15-.13-2.63 1.25-3.87 8.05-5.62 19.11-1.12 7.07-2.64 16.76-4.55 17.67-.06.03-.15.07-.37-.06-2.43-1.4-2.48-12.4-1.74-19.76l-1.91-.19c-.32 3.17-1.69 19.09 2.68 21.61.91.52 1.67.36 2.15.13 2.62-1.25 3.87-8.05 5.61-19.1 1.12-7.08 2.64-16.77 4.55-17.68.06-.03.15-.07.37.06 2.51 1.45 2.31 11.75 2.14 20.83-.24 12.37-.46 24.06 4.19 26.74.93.54 1.91.62 2.83.24 3.58-1.46 5.96-9.9 8.47-18.84 1.79-6.38 4.02-14.31 5.98-15.11.14-.06.27-.07.49.06 2.71 1.56 3.05 13.65 3.32 23.36.4 14.21.88 22.98 4.27 24.93.78.45 1.61.54 2.43.27 2.72-.9 4.84-5.84 7.08-11.06 1.71-3.98 3.84-8.93 5.54-9.5.23-.08.42-.05.66.08 2.97 1.72 3.45 18.76 2.84 30.31l1.93.09z'
          mask='url(#banner_svg__SVGID_66_)'
          fill='url(#banner_svg__SVGID_67_)'
        />
      </g>
    </mask>
    <linearGradient
      id='banner_svg__SVGID_68_'
      gradientUnits='userSpaceOnUse'
      x1={637.66}
      y1={191.086}
      x2={705.885}
      y2={191.086}
      gradientTransform='matrix(-1 0 0 1 1004.435 0)'
    >
      <stop offset={0} stopColor='#e9f2ff' />
      <stop offset={0.277} stopColor='#c7dbff' />
      <stop offset={0.562} stopColor='#abc8ff' />
      <stop offset={0.812} stopColor='#9abdff' />
      <stop offset={0.999} stopColor='#94b9ff' />
    </linearGradient>
    <path
      d='M366.52 228.3c.26-4.84 1.27-29.15-3.8-32.07-.71-.41-1.47-.49-2.22-.24-2.52.84-4.45 5.34-6.7 10.56-1.79 4.17-4.02 9.37-5.93 10-.3.1-.56.06-.87-.11-2.7-1.56-3.04-13.63-3.31-23.33-.4-14.23-.88-23.01-4.27-24.97-.7-.41-1.45-.47-2.17-.17-2.69 1.1-4.45 6.93-7.1 16.37-2.06 7.34-4.63 16.48-7.35 17.59-.25.1-.61.18-1.15-.13-3.67-2.12-3.43-14.83-3.23-25.04.24-12.71.22-20.6-3.09-22.52-.91-.52-1.67-.36-2.15-.13-2.63 1.25-3.87 8.05-5.62 19.11-1.12 7.07-2.64 16.76-4.55 17.67-.06.03-.15.07-.37-.06-2.43-1.4-2.48-12.4-1.74-19.76l-1.91-.19c-.32 3.17-1.69 19.09 2.68 21.61.91.52 1.67.36 2.15.13 2.62-1.25 3.87-8.05 5.61-19.1 1.12-7.08 2.64-16.77 4.55-17.68.06-.03.15-.07.37.06 2.51 1.45 2.31 11.75 2.14 20.83-.24 12.37-.46 24.06 4.19 26.74.93.54 1.91.62 2.83.24 3.58-1.46 5.96-9.9 8.47-18.84 1.79-6.38 4.02-14.31 5.98-15.11.14-.06.27-.07.49.06 2.71 1.56 3.05 13.65 3.32 23.36.4 14.21.88 22.98 4.27 24.93.78.45 1.61.54 2.43.27 2.72-.9 4.84-5.84 7.08-11.06 1.71-3.98 3.84-8.93 5.54-9.5.23-.08.42-.05.66.08 2.97 1.72 3.45 18.76 2.84 30.31l1.93.09z'
      fill='url(#banner_svg__SVGID_68_)'
    />
    <linearGradient
      id='banner_svg__SVGID_69_'
      gradientUnits='userSpaceOnUse'
      x1={633.558}
      y1={198.97}
      x2={691.658}
      y2={198.97}
      gradientTransform='matrix(-1 0 0 1 1004.435 0)'
    >
      <stop offset={0} stopColor='#fd8d1f' />
      <stop offset={1} stopColor='#fd5c1f' />
    </linearGradient>
    <path
      d='M370.66 230.58c.22-4.12 1.08-24.79-3.29-27.31-.64-.37-1.33-.44-2-.22-2.2.73-3.85 4.58-5.76 9.03-1.51 3.51-3.38 7.88-4.93 8.39-.15.05-.34.08-.61-.08-2.22-1.28-2.5-11.46-2.73-19.64-.34-12.11-.75-19.58-3.7-21.28-.64-.37-1.32-.42-1.97-.16-2.34.95-3.85 5.93-6.1 13.96-1.74 6.19-3.9 13.9-6.14 14.81-.2.08-.45.13-.85-.1-3.04-1.75-2.83-12.48-2.67-21.09.21-10.83.19-17.55-2.69-19.22-.64-.37-1.34-.41-1.96-.12-2.34 1.11-3.36 6.92-4.84 16.3-.89 5.63-2.23 14.13-3.77 14.86-.02.01-.05.03-.17-.04-1.2-.7-2.43-6.31-1.4-16.6l-1.91-.19c-.27 2.7-1.44 16.27 2.35 18.46.64.37 1.34.41 1.96.11 2.33-1.11 3.36-6.92 4.84-16.3.89-5.63 2.23-14.14 3.77-14.87.02-.01.06-.03.18.04 2.05 1.19 1.88 10.24 1.74 17.52-.2 10.53-.39 20.47 3.62 22.79.83.48 1.7.55 2.53.21 3.1-1.26 5.12-8.45 7.26-16.06 1.51-5.37 3.39-12.06 4.98-12.71.06-.03.13-.05.29.04 2.23 1.29 2.51 11.48 2.74 19.67.34 12.09.75 19.56 3.69 21.25.69.4 1.45.48 2.18.24 2.37-.79 4.18-5 6.09-9.46 1.44-3.35 3.23-7.51 4.61-7.97.13-.04.25-.05.44.06 2.46 1.42 2.85 15.8 2.34 25.55l1.88.13z'
      fill='url(#banner_svg__SVGID_69_)'
    />
    <linearGradient
      id='banner_svg__SVGID_70_'
      gradientUnits='userSpaceOnUse'
      x1={226.944}
      y1={192.792}
      x2={281.576}
      y2={192.792}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#e9efff' />
      <stop offset={1} stopColor='#d4e3ff' />
    </linearGradient>
    <path
      d='M290.54 196.43l-2.58 3.44-.12.16-1.57 2.09-5.98-1.23c-1.03.71-2.2 1.34-3.48 1.89l2.28 2.82.26.32-1.49.35-9.09 2.12-2.57-3.16c-1.61.12-3.25.14-4.89.05l-2.43 3.24-9.83-2.02-.4-.08-.45-.09.07-.1 2.36-3.14c-1.31-.53-2.48-1.13-3.51-1.79l-6 1.4-1.77-2.17-2.76-3.4 2.42-.56 3.53-.82c-.22-.86-.25-1.74-.09-2.62l-3.53-.73-2.45-.5 4.28-5.69 5.91 1.22c.23-.16.47-.32.71-.47.08-.06.17-.11.25-.16a21.94 21.94 0 012.53-1.3l-.3-.37-2.2-2.71 10.58-2.47 2.47 3.05c.64-.05 1.29-.08 1.95-.1.89-.03 1.78-.02 2.68.01.15.01.3.01.46.02l.66-.87.05-.06.22-.3 1.4-1.87 2.15.44 8.53 1.76-2.33 3.1c.74.3 1.43.62 2.08.96.55.29 1.07.59 1.54.91l5.79-1.35 4.52 5.58-3.02.7-2.82.66c.21.87.23 1.77.04 2.66l3.12.64 2.82.54z'
      fill='url(#banner_svg__SVGID_70_)'
    />
    <linearGradient
      id='banner_svg__SVGID_71_'
      gradientUnits='userSpaceOnUse'
      x1={248.548}
      y1={202.065}
      x2={265.657}
      y2={201.778}
      gradientTransform='matrix(.9928 .0169 -.0274 1.0067 13.753 -13.403)'
    >
      <stop offset={0} stopColor='#fd8d1f' />
      <stop offset={1} stopColor='#fd5c1f' />
    </linearGradient>
    <path
      d='M271.36 195.84c-1.75 2.32-6.69 3.47-11.05 2.58-4.36-.9-6.47-3.5-4.73-5.82 1.75-2.32 6.69-3.47 11.05-2.58 4.36.89 6.47 3.5 4.73 5.82z'
      fill='url(#banner_svg__SVGID_71_)'
    />
    <path className='banner_svg__st77' d='M279.09 205.59l.94-.6c-.31.21-.62.41-.94.6z' />
    <linearGradient
      id='banner_svg__SVGID_72_'
      gradientUnits='userSpaceOnUse'
      x1={237.6}
      y1={184.229}
      x2={240.304}
      y2={184.229}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#004daa' />
      <stop offset={1} stopColor='#0029e9' />
    </linearGradient>
    <path
      d='M250.18 185.47a21.94 21.94 0 00-2.53 1.3c-.08.05-.17.1-.25.16l.28-4.54 2.5 3.08z'
      fill='url(#banner_svg__SVGID_72_)'
    />
    <linearGradient
      id='banner_svg__SVGID_73_'
      gradientUnits='userSpaceOnUse'
      x1={266.736}
      y1={181.948}
      x2={268.888}
      y2={181.948}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#004daa' />
      <stop offset={1} stopColor='#0029e9' />
    </linearGradient>
    <path d='M278.83 181.99l-.25 4.06c-.65-.34-1.34-.66-2.08-.96l2.33-3.1z' fill='url(#banner_svg__SVGID_73_)' />
    <linearGradient
      id='banner_svg__SVGID_74_'
      gradientUnits='userSpaceOnUse'
      x1={275.351}
      y1={190.812}
      x2={281.131}
      y2={190.812}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#004daa' />
      <stop offset={1} stopColor='#0029e9' />
    </linearGradient>
    <path
      d='M290.43 191.19l-.26 4.1-2.42.56-3.12-.64c.19-.9.18-1.79-.03-2.66l2.82-.66 3.01-.7z'
      fill='url(#banner_svg__SVGID_74_)'
    />
    <linearGradient
      id='banner_svg__SVGID_75_'
      gradientUnits='userSpaceOnUse'
      x1={277.632}
      y1={198.591}
      x2={281.575}
      y2={198.591}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_75_)' d='M290.54 196.43l-.26 4.11-4.27 5.68.25-4.1 1.58-2.09z' />
    <linearGradient
      id='banner_svg__SVGID_76_'
      gradientUnits='userSpaceOnUse'
      x1={271.538}
      y1={201.071}
      x2={277.632}
      y2={201.071}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#004daa' />
      <stop offset={1} stopColor='#0029e9' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_76_)' d='M286.26 202.12l-.25 4.1-5.99-1.23.26-4.1z' />
    <linearGradient
      id='banner_svg__SVGID_77_'
      gradientUnits='userSpaceOnUse'
      x1={268.161}
      y1={200.942}
      x2={271.538}
      y2={200.942}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#025' />
      <stop offset={1} stopColor='#003a7f' />
    </linearGradient>
    <path
      d='M280.28 200.89l-.26 4.1-.94.6-2.28-2.82c1.28-.54 2.45-1.18 3.48-1.88z'
      fill='url(#banner_svg__SVGID_77_)'
    />
    <linearGradient
      id='banner_svg__SVGID_78_'
      gradientUnits='userSpaceOnUse'
      x1={260.444}
      y1={207.157}
      x2={270.92}
      y2={207.157}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_78_)' d='M279.35 205.92l-.26 4.1-10.57 2.47.26-4.11 9.08-2.12z' />
    <linearGradient
      id='banner_svg__SVGID_79_'
      gradientUnits='userSpaceOnUse'
      x1={257.661}
      y1={207.159}
      x2={260.444}
      y2={207.159}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#004daa' />
      <stop offset={1} stopColor='#0029e9' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_79_)' d='M268.78 208.38l-.26 4.11-2.57-3.17.26-4.1z' />
    <linearGradient
      id='banner_svg__SVGID_80_'
      gradientUnits='userSpaceOnUse'
      x1={252.748}
      y1={205.815}
      x2={257.661}
      y2={205.815}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#025' />
      <stop offset={1} stopColor='#003a7f' />
    </linearGradient>
    <path
      d='M266.21 205.22l-.26 4.1c-1.61.12-3.25.14-4.89.06l.26-4.1c1.64.08 3.28.06 4.89-.06z'
      fill='url(#banner_svg__SVGID_80_)'
    />
    <linearGradient
      id='banner_svg__SVGID_81_'
      gradientUnits='userSpaceOnUse'
      x1={250.506}
      y1={207.641}
      x2={252.748}
      y2={207.641}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#004daa' />
      <stop offset={1} stopColor='#0029e9' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_81_)' d='M261.32 205.28l-.26 4.1-2.43 3.23.26-4.1z' />
    <linearGradient
      id='banner_svg__SVGID_82_'
      gradientUnits='userSpaceOnUse'
      x1={238.239}
      y1={203.144}
      x2={241.875}
      y2={203.144}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#025' />
      <stop offset={1} stopColor='#003a7f' />
    </linearGradient>
    <path
      d='M250.64 203.08l-2.36 3.13c-.5-.26-.96-.53-1.4-.82l.26-4.1c1.02.66 2.19 1.26 3.5 1.79z'
      fill='url(#banner_svg__SVGID_82_)'
    />
    <linearGradient
      id='banner_svg__SVGID_83_'
      gradientUnits='userSpaceOnUse'
      x1={239.632}
      y1={208.502}
      x2={250.506}
      y2={208.502}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_83_)' d='M258.89 208.51l-.26 4.1-10.68-2.19.26-4.11.45.09.4.09z' />
    <linearGradient
      id='banner_svg__SVGID_84_'
      gradientUnits='userSpaceOnUse'
      x1={232.29}
      y1={203.63}
      x2={238.239}
      y2={203.63}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#004daa' />
      <stop offset={1} stopColor='#0029e9' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_84_)' d='M247.14 201.29l-.26 4.11-6 1.4.25-4.11z' />
    <linearGradient
      id='banner_svg__SVGID_85_'
      gradientUnits='userSpaceOnUse'
      x1={227.39}
      y1={201.84}
      x2={232.29}
      y2={201.84}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_85_)' d='M241.13 202.69l-.25 4.11-4.53-5.58.26-4.1 2.76 3.4z' />
    <linearGradient
      id='banner_svg__SVGID_86_'
      gradientUnits='userSpaceOnUse'
      x1={226.945}
      y1={194.216}
      x2={233.291}
      y2={194.216}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#004daa' />
      <stop offset={1} stopColor='#0029e9' />
    </linearGradient>
    <path
      d='M242.57 195.73l-3.54.82-2.79-.57.26-4.1 2.45.5 3.53.73c-.17.88-.13 1.76.09 2.62z'
      fill='url(#banner_svg__SVGID_86_)'
    />
    <linearGradient
      id='banner_svg__SVGID_87_'
      gradientUnits='userSpaceOnUse'
      x1={237.601}
      y1={187.739}
      x2={281.576}
      y2={187.739}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#d4e3ff' />
      <stop offset={1} stopColor='#e9efff' />
    </linearGradient>
    <path
      d='M290.54 196.43l-2.58 3.44c-11.95-11.39-26.33-14.54-38.07-14.77l-2.2-2.71 10.58-2.47 2.47 3.05c.64-.05 1.29-.08 1.95-.1.89-.03 1.78-.02 2.68.01.15.01.3.01.46.02l.66-.87.05-.06.22-.3 1.4-1.87 2.15.44 8.53 1.76-2.33 3.1c.74.3 1.43.62 2.08.96.55.29 1.07.59 1.54.91l5.79-1.35 4.52 5.58-3.02.7-2.82.66c.21.87.23 1.77.04 2.66l3.12.64 2.78.57z'
      fill='url(#banner_svg__SVGID_87_)'
    />
    <linearGradient
      id='banner_svg__SVGID_88_'
      gradientUnits='userSpaceOnUse'
      x1={377.958}
      y1={209.87}
      x2={410.233}
      y2={209.87}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#e9efff' />
      <stop offset={1} stopColor='#d4e3ff' />
    </linearGradient>
    <path
      d='M417.01 220.08l-1.53 2.03-.07.1-.93 1.23-3.53-.73c-.61.42-1.3.79-2.06 1.12l1.35 1.66.15.19-.88.21-5.37 1.25-1.52-1.87c-.95.07-1.92.08-2.89.03l-1.44 1.91-5.81-1.2-.24-.05-.26-.06.04-.06 1.39-1.85c-.77-.31-1.47-.67-2.07-1.06l-3.55.83-1.04-1.28-1.63-2.01 1.43-.33 2.09-.49c-.13-.51-.15-1.03-.05-1.55l-2.09-.43-1.45-.3 2.53-3.36 3.49.72c.14-.1.28-.19.42-.28l.15-.09c.19-.11.38-.22.58-.33.29-.15.59-.3.91-.44l-.18-.22-1.3-1.6 6.25-1.46 1.46 1.8c.38-.03.76-.05 1.15-.06.53-.02 1.05-.01 1.59.01.09 0 .18.01.27.01l.39-.52.03-.04.13-.18.83-1.1 1.27.26 5.04 1.04-1.38 1.83c.44.18.85.36 1.23.57.33.17.63.35.91.54l3.42-.8 2.67 3.29-1.78.41-1.67.39c.12.52.13 1.04.02 1.57l1.84.38 1.69.37z'
      fill='url(#banner_svg__SVGID_88_)'
    />
    <linearGradient
      id='banner_svg__SVGID_89_'
      gradientUnits='userSpaceOnUse'
      x1={391.204}
      y1={223.979}
      x2={401.311}
      y2={223.979}
      gradientTransform='matrix(.9928 .0169 -.0274 1.0067 13.753 -13.403)'
    >
      <stop offset={0} stopColor='#fd8d1f' />
      <stop offset={1} stopColor='#fd5c1f' />
    </linearGradient>
    <path
      d='M405.68 219.73c-1.03 1.37-3.95 2.05-6.53 1.52-2.57-.53-3.82-2.07-2.79-3.44 1.03-1.37 3.95-2.05 6.53-1.52 2.57.53 3.82 2.07 2.79 3.44z'
      fill='url(#banner_svg__SVGID_89_)'
    />
    <path className='banner_svg__st77' d='M410.24 225.49l.55-.35c-.17.12-.35.24-.55.35z' />
    <linearGradient
      id='banner_svg__SVGID_90_'
      gradientUnits='userSpaceOnUse'
      x1={384.254}
      y1={204.811}
      x2={385.851}
      y2={204.811}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#004daa' />
      <stop offset={1} stopColor='#0029e9' />
    </linearGradient>
    <path
      d='M393.17 213.61c-.32.14-.62.28-.91.44-.2.11-.4.22-.58.33l-.15.09.17-2.68 1.47 1.82z'
      fill='url(#banner_svg__SVGID_90_)'
    />
    <linearGradient
      id='banner_svg__SVGID_91_'
      gradientUnits='userSpaceOnUse'
      x1={401.466}
      y1={203.464}
      x2={402.738}
      y2={203.464}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#004daa' />
      <stop offset={1} stopColor='#0029e9' />
    </linearGradient>
    <path d='M410.09 211.55l-.15 2.4c-.38-.2-.79-.39-1.23-.57l1.38-1.83z' fill='url(#banner_svg__SVGID_91_)' />
    <linearGradient
      id='banner_svg__SVGID_92_'
      gradientUnits='userSpaceOnUse'
      x1={406.555}
      y1={208.7}
      x2={409.97}
      y2={208.7}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#004daa' />
      <stop offset={1} stopColor='#0029e9' />
    </linearGradient>
    <path
      d='M416.95 216.99l-.15 2.42-1.43.33-1.84-.38c.11-.53.1-1.06-.02-1.57l1.67-.39 1.77-.41z'
      fill='url(#banner_svg__SVGID_92_)'
    />
    <linearGradient
      id='banner_svg__SVGID_93_'
      gradientUnits='userSpaceOnUse'
      x1={407.903}
      y1={213.296}
      x2={410.233}
      y2={213.296}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_93_)' d='M417.01 220.08l-.15 2.43-2.53 3.36.16-2.43.92-1.23z' />
    <linearGradient
      id='banner_svg__SVGID_94_'
      gradientUnits='userSpaceOnUse'
      x1={404.303}
      y1={214.761}
      x2={407.903}
      y2={214.761}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#004daa' />
      <stop offset={1} stopColor='#0029e9' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_94_)' d='M414.49 223.44l-.16 2.43-3.53-.73.15-2.43z' />
    <linearGradient
      id='banner_svg__SVGID_95_'
      gradientUnits='userSpaceOnUse'
      x1={402.308}
      y1={214.684}
      x2={404.303}
      y2={214.684}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#025' />
      <stop offset={1} stopColor='#003a7f' />
    </linearGradient>
    <path
      d='M410.95 222.71l-.15 2.42-.55.35-1.35-1.66c.75-.31 1.44-.69 2.05-1.11z'
      fill='url(#banner_svg__SVGID_95_)'
    />
    <linearGradient
      id='banner_svg__SVGID_96_'
      gradientUnits='userSpaceOnUse'
      x1={397.749}
      y1={218.356}
      x2={403.938}
      y2={218.356}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_96_)' d='M410.4 225.69l-.15 2.42-6.25 1.46.15-2.43 5.37-1.25z' />
    <linearGradient
      id='banner_svg__SVGID_97_'
      gradientUnits='userSpaceOnUse'
      x1={396.105}
      y1={218.357}
      x2={397.749}
      y2={218.357}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#004daa' />
      <stop offset={1} stopColor='#0029e9' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_97_)' d='M404.15 227.14l-.15 2.43-1.51-1.87.15-2.43z' />
    <linearGradient
      id='banner_svg__SVGID_98_'
      gradientUnits='userSpaceOnUse'
      x1={393.202}
      y1={217.563}
      x2={396.105}
      y2={217.563}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#025' />
      <stop offset={1} stopColor='#003a7f' />
    </linearGradient>
    <path
      d='M402.64 225.27l-.15 2.42c-.95.07-1.92.08-2.89.03l.15-2.42c.97.06 1.94.04 2.89-.03z'
      fill='url(#banner_svg__SVGID_98_)'
    />
    <linearGradient
      id='banner_svg__SVGID_99_'
      gradientUnits='userSpaceOnUse'
      x1={391.878}
      y1={218.642}
      x2={393.202}
      y2={218.642}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#004daa' />
      <stop offset={1} stopColor='#0029e9' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_99_)' d='M399.75 225.31l-.15 2.42-1.44 1.91.15-2.42z' />
    <linearGradient
      id='banner_svg__SVGID_100_'
      gradientUnits='userSpaceOnUse'
      x1={384.631}
      y1={215.986}
      x2={386.779}
      y2={215.986}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#025' />
      <stop offset={1} stopColor='#003a7f' />
    </linearGradient>
    <path
      d='M393.44 224.01l-1.39 1.85c-.29-.15-.57-.32-.83-.48l.15-2.42c.6.38 1.3.74 2.07 1.05z'
      fill='url(#banner_svg__SVGID_100_)'
    />
    <linearGradient
      id='banner_svg__SVGID_101_'
      gradientUnits='userSpaceOnUse'
      x1={385.454}
      y1={219.15}
      x2={391.878}
      y2={219.15}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_101_)' d='M398.31 227.22l-.15 2.42-6.31-1.3.15-2.42.27.05.23.05z' />
    <linearGradient
      id='banner_svg__SVGID_102_'
      gradientUnits='userSpaceOnUse'
      x1={381.117}
      y1={216.273}
      x2={384.631}
      y2={216.273}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#004daa' />
      <stop offset={1} stopColor='#0029e9' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_102_)' d='M391.37 222.95l-.15 2.43-3.55.83.15-2.43z' />
    <linearGradient
      id='banner_svg__SVGID_103_'
      gradientUnits='userSpaceOnUse'
      x1={378.222}
      y1={215.215}
      x2={381.117}
      y2={215.215}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_103_)' d='M387.82 223.78l-.15 2.43-2.67-3.3.15-2.42 1.63 2.01z' />
    <linearGradient
      id='banner_svg__SVGID_104_'
      gradientUnits='userSpaceOnUse'
      x1={377.959}
      y1={210.711}
      x2={381.708}
      y2={210.711}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#004daa' />
      <stop offset={1} stopColor='#0029e9' />
    </linearGradient>
    <path
      d='M388.67 219.67l-2.09.49-1.65-.34.15-2.42 1.45.3 2.09.43c-.1.51-.08 1.03.05 1.54z'
      fill='url(#banner_svg__SVGID_104_)'
    />
    <linearGradient
      id='banner_svg__SVGID_105_'
      gradientUnits='userSpaceOnUse'
      x1={384.254}
      y1={206.885}
      x2={410.233}
      y2={206.885}
      gradientTransform='matrix(.9912 .053 -.063 1.0055 23.642 -13.174)'
    >
      <stop offset={0} stopColor='#d4e3ff' />
      <stop offset={1} stopColor='#e9efff' />
    </linearGradient>
    <path
      d='M417.01 220.08l-1.53 2.03c-7.06-6.73-15.55-8.59-22.49-8.73l-1.3-1.6 6.25-1.46 1.46 1.8c.38-.03.76-.05 1.15-.06.53-.02 1.05-.01 1.59.01.09 0 .18.01.27.01l.39-.52.03-.04.13-.18.83-1.1 1.27.26 5.04 1.04-1.38 1.83c.44.18.85.36 1.23.57.33.17.63.35.91.54l3.42-.8 2.67 3.29-1.78.41-1.67.39c.12.52.13 1.04.02 1.57l1.84.38 1.65.36z'
      fill='url(#banner_svg__SVGID_105_)'
    />
    <path className='banner_svg__st2' d='M115.16 292.47L73.4 316.58l-41.75-24.12 41.4-23.9.35-.21z' />
    <linearGradient
      id='banner_svg__SVGID_106_'
      gradientUnits='userSpaceOnUse'
      x1={31.647}
      y1={311.402}
      x2={73.403}
      y2={311.402}
    >
      <stop offset={0} stopColor='#e9efff' />
      <stop offset={1} stopColor='#d4e3ff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_106_)' d='M31.65 292.46v13.78l41.75 24.1v-13.76z' />
    <linearGradient
      id='banner_svg__SVGID_107_'
      gradientUnits='userSpaceOnUse'
      x1={73.403}
      y1={311.406}
      x2={115.158}
      y2={311.406}
    >
      <stop offset={0} stopColor='#e9efff' />
      <stop offset={1} stopColor='#d4e3ff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_107_)' d='M73.4 330.34l41.76-24.1v-13.77L73.4 316.58z' />
    <linearGradient
      id='banner_svg__SVGID_108_'
      gradientUnits='userSpaceOnUse'
      x1={59.699}
      y1={315.924}
      x2={61.958}
      y2={315.924}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M59.87 314.9c-.15.21-.2.51-.15.81.03.25.13.51.28.75.07.11.15.22.24.32.53.57 1.23.64 1.55.17.33-.47.16-1.31-.37-1.88-.53-.57-1.23-.64-1.55-.17z'
      fill='url(#banner_svg__SVGID_108_)'
    />
    <linearGradient
      id='banner_svg__SVGID_109_'
      gradientUnits='userSpaceOnUse'
      x1={63.326}
      y1={318.112}
      x2={65.585}
      y2={318.112}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M63.49 317.09c-.15.21-.2.51-.15.81.03.25.13.51.28.75.07.11.15.22.24.32.53.57 1.23.64 1.55.17.33-.47.16-1.31-.37-1.88-.52-.57-1.22-.65-1.55-.17z'
      fill='url(#banner_svg__SVGID_109_)'
    />
    <linearGradient
      id='banner_svg__SVGID_110_'
      gradientUnits='userSpaceOnUse'
      x1={66.953}
      y1={320.225}
      x2={69.212}
      y2={320.225}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M67.12 319.2c-.15.21-.2.51-.15.81.03.25.13.51.28.75.07.11.15.22.24.32.53.57 1.23.64 1.55.17.33-.47.16-1.31-.37-1.88-.53-.57-1.22-.64-1.55-.17z'
      fill='url(#banner_svg__SVGID_110_)'
    />
    <linearGradient
      id='banner_svg__SVGID_111_'
      gradientUnits='userSpaceOnUse'
      x1={38.233}
      y1={304.584}
      x2={42.966}
      y2={304.584}
    >
      <stop offset={0} stopColor='#ff0007' />
      <stop offset={1} stopColor='#ffaaac' />
    </linearGradient>
    <path
      d='M38.23 302.7v1.19c0 .15.08.28.21.36l4.21 2.43c.14.08.32-.02.32-.18v-1.17c0-.18-.09-.34-.25-.43l-4.14-2.39c-.16-.1-.35.01-.35.19z'
      fill='url(#banner_svg__SVGID_111_)'
    />
    <linearGradient
      id='banner_svg__SVGID_112_'
      gradientUnits='userSpaceOnUse'
      x1={109.194}
      y1={301.928}
      x2={111.453}
      y2={301.928}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M111.28 300.9c.15.21.2.51.15.81-.03.25-.13.51-.28.75-.07.11-.15.22-.24.32-.53.57-1.23.64-1.55.17-.33-.47-.16-1.31.37-1.88.53-.56 1.23-.64 1.55-.17z'
      fill='url(#banner_svg__SVGID_112_)'
    />
    <linearGradient
      id='banner_svg__SVGID_113_'
      gradientUnits='userSpaceOnUse'
      x1={105.567}
      y1={304.116}
      x2={107.825}
      y2={304.116}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M107.66 303.09c.15.21.2.51.15.81-.03.25-.13.51-.28.75-.07.11-.15.22-.24.32-.53.57-1.23.64-1.55.17-.33-.47-.16-1.31.37-1.88.52-.56 1.22-.64 1.55-.17z'
      fill='url(#banner_svg__SVGID_113_)'
    />
    <linearGradient
      id='banner_svg__SVGID_114_'
      gradientUnits='userSpaceOnUse'
      x1={101.94}
      y1={306.229}
      x2={104.199}
      y2={306.229}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M104.03 305.2c.15.21.2.51.15.81-.03.25-.13.51-.28.75-.07.11-.15.22-.24.32-.53.57-1.23.64-1.55.17-.33-.47-.16-1.31.37-1.88.53-.56 1.22-.64 1.55-.17z'
      fill='url(#banner_svg__SVGID_114_)'
    />
    <linearGradient
      id='banner_svg__SVGID_115_'
      gradientUnits='userSpaceOnUse'
      x1={79.987}
      y1={318.318}
      x2={84.72}
      y2={318.318}
    >
      <stop offset={0} stopColor='#ff0007' />
      <stop offset={1} stopColor='#ffaaac' />
    </linearGradient>
    <path
      d='M84.72 316.43v1.19c0 .15-.08.28-.21.36l-4.21 2.43c-.14.08-.32-.02-.32-.18v-1.17c0-.18.09-.34.25-.43l4.14-2.39c.16-.1.35.01.35.19z'
      fill='url(#banner_svg__SVGID_115_)'
    />
    <linearGradient
      id='banner_svg__SVGID_116_'
      gradientUnits='userSpaceOnUse'
      x1={35.129}
      y1={291.963}
      x2={37.621}
      y2={291.963}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M37.62 290.38v2.31c0 .47-.56.85-1.24.85-.69 0-1.25-.38-1.25-.85v-2.31c0 .47.56.85 1.25.85.68 0 1.24-.38 1.24-.85z'
      fill='url(#banner_svg__SVGID_116_)'
    />
    <linearGradient
      id='banner_svg__SVGID_117_'
      gradientUnits='userSpaceOnUse'
      x1={35.129}
      y1={290.384}
      x2={37.621}
      y2={290.384}
    >
      <stop offset={0} stopColor='#e9efff' />
      <stop offset={1} stopColor='#d4e3ff' />
    </linearGradient>
    <path
      d='M37.62 290.38c0 .47-.56.85-1.24.85-.69 0-1.25-.38-1.25-.85s.56-.85 1.25-.85c.68.01 1.24.39 1.24.85z'
      fill='url(#banner_svg__SVGID_117_)'
    />
    <linearGradient
      id='banner_svg__SVGID_118_'
      gradientUnits='userSpaceOnUse'
      x1={72.164}
      y1={270.499}
      x2={74.655}
      y2={270.499}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M74.66 268.92v2.31c0 .47-.56.85-1.24.85s-1.25-.38-1.25-.85v-2.31c0 .47.56.85 1.25.85s1.24-.38 1.24-.85z'
      fill='url(#banner_svg__SVGID_118_)'
    />
    <defs>
      <filter
        id='banner_svg__Adobe_OpacityMaskFilter_8_'
        filterUnits='userSpaceOnUse'
        x={73.05}
        y={268.35}
        width={42.11}
        height={48.22}
      >
        <feFlood result='back' floodColor='#fff' floodOpacity={1} />
        <feBlend in='SourceGraphic' in2='back' />
      </filter>
    </defs>
    <mask maskUnits='userSpaceOnUse' x={73.05} y={268.35} width={42.11} height={48.22} id='banner_svg__SVGID_119_'>
      <g filter='url(#banner_svg__Adobe_OpacityMaskFilter_8_)'>
        <defs>
          <filter
            id='banner_svg__Adobe_OpacityMaskFilter_9_'
            filterUnits='userSpaceOnUse'
            x={73.05}
            y={268.35}
            width={42.11}
            height={48.22}
          >
            <feFlood result='back' floodColor='#fff' floodOpacity={1} />
            <feBlend in='SourceGraphic' in2='back' />
          </filter>
        </defs>
        <linearGradient
          id='banner_svg__SVGID_120_'
          gradientUnits='userSpaceOnUse'
          x1={73.052}
          y1={292.465}
          x2={115.158}
          y2={292.465}
        >
          <stop offset={0} stopColor='#666' />
          <stop offset={0.056} stopColor='#737373' />
          <stop offset={0.284} stopColor='#a5a5a5' />
          <stop offset={0.5} stopColor='#ccc' />
          <stop offset={0.698} stopColor='#e8e8e8' />
          <stop offset={0.87} stopColor='#f9f9f9' />
          <stop offset={0.999} stopColor='#fff' />
        </linearGradient>
        <path
          d='M73.4 316.58s7.52-28.47-.35-48.02l.35-.2 41.76 24.11-41.76 24.11z'
          mask='url(#banner_svg__SVGID_119_)'
          fill='url(#banner_svg__SVGID_120_)'
        />
      </g>
    </mask>
    <linearGradient
      id='banner_svg__SVGID_121_'
      gradientUnits='userSpaceOnUse'
      x1={73.052}
      y1={292.465}
      x2={115.158}
      y2={292.465}
    >
      <stop offset={0} stopColor='#e9f2ff' />
      <stop offset={0.547} stopColor='#daeaff' />
      <stop offset={0.999} stopColor='#d4e7ff' />
    </linearGradient>
    <path d='M73.4 316.58s7.52-28.47-.35-48.02l.35-.2 41.76 24.11-41.76 24.11z' fill='url(#banner_svg__SVGID_121_)' />
    <linearGradient
      id='banner_svg__SVGID_122_'
      gradientUnits='userSpaceOnUse'
      x1={72.164}
      y1={268.92}
      x2={74.655}
      y2={268.92}
    >
      <stop offset={0} stopColor='#e9efff' />
      <stop offset={1} stopColor='#d4e3ff' />
    </linearGradient>
    <path
      d='M74.66 268.92c0 .47-.56.85-1.24.85s-1.25-.38-1.25-.85.56-.85 1.25-.85 1.24.38 1.24.85z'
      fill='url(#banner_svg__SVGID_122_)'
    />
    <linearGradient
      id='banner_svg__SVGID_123_'
      gradientUnits='userSpaceOnUse'
      x1={110.207}
      y1={291.653}
      x2={112.698}
      y2={291.653}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M112.7 290.07v2.31c0 .47-.56.85-1.24.85-.69 0-1.25-.38-1.25-.85v-2.31c0 .47.56.85 1.25.85.68 0 1.24-.38 1.24-.85z'
      fill='url(#banner_svg__SVGID_123_)'
    />
    <linearGradient
      id='banner_svg__SVGID_124_'
      gradientUnits='userSpaceOnUse'
      x1={110.207}
      y1={290.074}
      x2={112.698}
      y2={290.074}
    >
      <stop offset={0} stopColor='#e9efff' />
      <stop offset={1} stopColor='#d4e3ff' />
    </linearGradient>
    <path
      d='M112.7 290.07c0 .47-.56.85-1.24.85-.69 0-1.25-.38-1.25-.85s.56-.85 1.25-.85c.68.01 1.24.39 1.24.85z'
      fill='url(#banner_svg__SVGID_124_)'
    />
    <linearGradient
      id='banner_svg__SVGID_125_'
      gradientUnits='userSpaceOnUse'
      x1={72.157}
      y1={313.01}
      x2={74.648}
      y2={313.01}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M74.65 311.43v2.31c0 .47-.56.85-1.24.85s-1.25-.38-1.25-.85v-2.31c0 .47.56.85 1.25.85s1.24-.38 1.24-.85z'
      fill='url(#banner_svg__SVGID_125_)'
    />
    <linearGradient
      id='banner_svg__SVGID_126_'
      gradientUnits='userSpaceOnUse'
      x1={72.157}
      y1={311.43}
      x2={74.648}
      y2={311.43}
    >
      <stop offset={0} stopColor='#e9efff' />
      <stop offset={1} stopColor='#d4e3ff' />
    </linearGradient>
    <path
      d='M74.65 311.43c0 .47-.56.85-1.24.85s-1.25-.38-1.25-.85.56-.85 1.25-.85 1.24.38 1.24.85z'
      fill='url(#banner_svg__SVGID_126_)'
    />
    <linearGradient
      id='banner_svg__SVGID_127_'
      gradientUnits='userSpaceOnUse'
      x1={31.671}
      y1={325.184}
      x2={73.426}
      y2={325.184}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_127_)' d='M31.67 306.24v13.78l41.76 24.11v-13.77z' />
    <linearGradient
      id='banner_svg__SVGID_128_'
      gradientUnits='userSpaceOnUse'
      x1={73.426}
      y1={325.188}
      x2={115.181}
      y2={325.188}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_128_)' d='M73.43 344.13l41.75-24.11v-13.77l-41.75 24.11z' />
    <linearGradient
      id='banner_svg__SVGID_129_'
      gradientUnits='userSpaceOnUse'
      x1={59.722}
      y1={329.707}
      x2={61.981}
      y2={329.707}
    >
      <stop offset={0} stopColor='#e9efff' />
      <stop offset={1} stopColor='#d4e3ff' />
    </linearGradient>
    <path
      d='M59.89 328.68c-.15.21-.2.51-.15.81.03.25.13.51.28.75.07.11.15.22.24.32.53.57 1.23.64 1.55.17.33-.47.16-1.31-.37-1.88-.53-.56-1.22-.64-1.55-.17z'
      fill='url(#banner_svg__SVGID_129_)'
    />
    <linearGradient
      id='banner_svg__SVGID_130_'
      gradientUnits='userSpaceOnUse'
      x1={63.349}
      y1={331.895}
      x2={65.608}
      y2={331.895}
    >
      <stop offset={0} stopColor='#e9efff' />
      <stop offset={1} stopColor='#d4e3ff' />
    </linearGradient>
    <path
      d='M63.52 330.87c-.15.21-.2.51-.15.81.03.25.13.51.28.75.07.11.15.22.24.32.53.57 1.23.64 1.55.17.33-.47.16-1.31-.37-1.88-.53-.57-1.23-.64-1.55-.17z'
      fill='url(#banner_svg__SVGID_130_)'
    />
    <linearGradient
      id='banner_svg__SVGID_131_'
      gradientUnits='userSpaceOnUse'
      x1={66.976}
      y1={334.008}
      x2={69.235}
      y2={334.008}
    >
      <stop offset={0} stopColor='#e9efff' />
      <stop offset={1} stopColor='#d4e3ff' />
    </linearGradient>
    <path
      d='M67.14 332.98c-.15.21-.2.51-.15.81.03.25.13.51.28.75.07.11.15.22.24.32.53.57 1.23.64 1.55.17.33-.47.16-1.31-.37-1.88-.52-.56-1.22-.64-1.55-.17z'
      fill='url(#banner_svg__SVGID_131_)'
    />
    <path
      className='banner_svg__st2'
      d='M38.26 316.48v1.19c0 .15.08.28.21.36l4.21 2.43c.14.08.32-.02.32-.18v-1.17c0-.18-.09-.34-.25-.43l-4.14-2.39c-.16-.1-.35.01-.35.19z'
    />
    <linearGradient
      id='banner_svg__SVGID_132_'
      gradientUnits='userSpaceOnUse'
      x1={109.217}
      y1={315.711}
      x2={111.476}
      y2={315.711}
    >
      <stop offset={0} stopColor='#e9efff' />
      <stop offset={1} stopColor='#d4e3ff' />
    </linearGradient>
    <path
      d='M111.31 314.68c.15.21.2.51.15.81-.03.25-.13.51-.28.75-.07.11-.15.22-.24.32-.53.57-1.23.64-1.55.17-.33-.47-.16-1.31.37-1.88.52-.56 1.22-.64 1.55-.17z'
      fill='url(#banner_svg__SVGID_132_)'
    />
    <linearGradient
      id='banner_svg__SVGID_133_'
      gradientUnits='userSpaceOnUse'
      x1={105.59}
      y1={317.899}
      x2={107.849}
      y2={317.899}
    >
      <stop offset={0} stopColor='#e9efff' />
      <stop offset={1} stopColor='#d4e3ff' />
    </linearGradient>
    <path
      d='M107.68 316.87c.15.21.2.51.15.81-.03.25-.13.51-.28.75-.07.11-.15.22-.24.32-.53.57-1.23.64-1.55.17-.33-.47-.16-1.31.37-1.88.53-.56 1.22-.64 1.55-.17z'
      fill='url(#banner_svg__SVGID_133_)'
    />
    <linearGradient
      id='banner_svg__SVGID_134_'
      gradientUnits='userSpaceOnUse'
      x1={101.963}
      y1={320.012}
      x2={104.222}
      y2={320.012}
    >
      <stop offset={0} stopColor='#e9efff' />
      <stop offset={1} stopColor='#d4e3ff' />
    </linearGradient>
    <path
      d='M104.05 318.98c.15.21.2.51.15.81-.03.25-.13.51-.28.75-.07.11-.15.22-.24.32-.53.57-1.23.64-1.55.17-.33-.47-.16-1.31.37-1.88.53-.56 1.23-.64 1.55-.17z'
      fill='url(#banner_svg__SVGID_134_)'
    />
    <path
      className='banner_svg__st2'
      d='M84.74 330.21v1.19c0 .15-.08.28-.21.36l-4.21 2.43c-.14.08-.32-.02-.32-.18v-1.17c0-.18.09-.34.25-.43l4.14-2.39c.16-.09.35.02.35.19z'
    />
    <linearGradient
      id='banner_svg__SVGID_135_'
      gradientUnits='userSpaceOnUse'
      x1={31.648}
      y1={338.947}
      x2={73.403}
      y2={338.947}
    >
      <stop offset={0} stopColor='#e9efff' />
      <stop offset={1} stopColor='#d4e3ff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_135_)' d='M31.65 320.01v13.77l41.75 24.11v-13.77z' />
    <linearGradient
      id='banner_svg__SVGID_136_'
      gradientUnits='userSpaceOnUse'
      x1={73.403}
      y1={338.95}
      x2={115.159}
      y2={338.95}
    >
      <stop offset={0} stopColor='#e9efff' />
      <stop offset={1} stopColor='#d4e3ff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_136_)' d='M73.4 357.89l41.76-24.11v-13.77L73.4 344.12z' />
    <linearGradient
      id='banner_svg__SVGID_137_'
      gradientUnits='userSpaceOnUse'
      x1={59.699}
      y1={343.469}
      x2={61.958}
      y2={343.469}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M59.87 342.44c-.15.21-.2.51-.15.81.03.25.13.51.28.75.07.11.15.22.24.32.53.57 1.23.64 1.55.17.33-.47.16-1.31-.37-1.88-.53-.56-1.22-.64-1.55-.17z'
      fill='url(#banner_svg__SVGID_137_)'
    />
    <linearGradient
      id='banner_svg__SVGID_138_'
      gradientUnits='userSpaceOnUse'
      x1={63.326}
      y1={345.657}
      x2={65.585}
      y2={345.657}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M63.49 344.63c-.15.21-.2.51-.15.81.03.25.13.51.28.75.07.11.15.22.24.32.53.57 1.23.64 1.55.17.33-.47.16-1.31-.37-1.88-.52-.56-1.22-.64-1.55-.17z'
      fill='url(#banner_svg__SVGID_138_)'
    />
    <linearGradient
      id='banner_svg__SVGID_139_'
      gradientUnits='userSpaceOnUse'
      x1={66.953}
      y1={347.77}
      x2={69.212}
      y2={347.77}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M67.12 346.74c-.15.21-.2.51-.15.81.03.25.13.51.28.75.07.11.15.22.24.32.53.57 1.23.64 1.55.17.33-.47.16-1.31-.37-1.88-.52-.56-1.22-.64-1.55-.17z'
      fill='url(#banner_svg__SVGID_139_)'
    />
    <linearGradient
      id='banner_svg__SVGID_140_'
      gradientUnits='userSpaceOnUse'
      x1={38.233}
      y1={332.129}
      x2={42.966}
      y2={332.129}
    >
      <stop offset={0} stopColor='#ff0007' />
      <stop offset={1} stopColor='#ffaaac' />
    </linearGradient>
    <path
      d='M38.23 330.24v1.19c0 .15.08.28.21.36l4.21 2.43c.14.08.32-.02.32-.18v-1.17c0-.18-.09-.34-.25-.43l-4.14-2.39c-.16-.1-.35.02-.35.19z'
      fill='url(#banner_svg__SVGID_140_)'
    />
    <linearGradient
      id='banner_svg__SVGID_141_'
      gradientUnits='userSpaceOnUse'
      x1={109.194}
      y1={329.473}
      x2={111.453}
      y2={329.473}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M111.28 328.45c.15.21.2.51.15.81-.03.25-.13.51-.28.75-.07.11-.15.22-.24.32-.53.57-1.23.64-1.55.17-.33-.47-.16-1.31.37-1.88.53-.57 1.23-.65 1.55-.17z'
      fill='url(#banner_svg__SVGID_141_)'
    />
    <linearGradient
      id='banner_svg__SVGID_142_'
      gradientUnits='userSpaceOnUse'
      x1={105.567}
      y1={331.661}
      x2={107.826}
      y2={331.661}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M107.66 330.63c.15.21.2.51.15.81-.03.25-.13.51-.28.75-.07.11-.15.22-.24.32-.53.57-1.23.64-1.55.17-.33-.47-.16-1.31.37-1.88.52-.56 1.22-.64 1.55-.17z'
      fill='url(#banner_svg__SVGID_142_)'
    />
    <linearGradient
      id='banner_svg__SVGID_143_'
      gradientUnits='userSpaceOnUse'
      x1={101.94}
      y1={333.774}
      x2={104.199}
      y2={333.774}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M104.03 332.75c.15.21.2.51.15.81-.03.25-.13.51-.28.75-.07.11-.15.22-.24.32-.53.57-1.23.64-1.55.17-.33-.47-.16-1.31.37-1.88.53-.57 1.22-.64 1.55-.17z'
      fill='url(#banner_svg__SVGID_143_)'
    />
    <linearGradient
      id='banner_svg__SVGID_144_'
      gradientUnits='userSpaceOnUse'
      x1={79.987}
      y1={345.863}
      x2={84.721}
      y2={345.863}
    >
      <stop offset={0} stopColor='#ff0007' />
      <stop offset={1} stopColor='#ffaaac' />
    </linearGradient>
    <path
      d='M84.72 343.98v1.19c0 .15-.08.28-.21.36l-4.21 2.43c-.14.08-.32-.02-.32-.18v-1.17c0-.18.09-.34.25-.43l4.14-2.39c.16-.1.35.01.35.19z'
      fill='url(#banner_svg__SVGID_144_)'
    />
    <linearGradient
      id='banner_svg__SVGID_145_'
      gradientUnits='userSpaceOnUse'
      x1={201.338}
      y1={262.164}
      x2={214.264}
      y2={262.164}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_145_)' d='M214.26 262.16l-6.46 3.74-6.46-3.74 6.46-3.73z' />
    <linearGradient
      id='banner_svg__SVGID_146_'
      gradientUnits='userSpaceOnUse'
      x1={207.802}
      y1={264.389}
      x2={214.264}
      y2={264.389}
    >
      <stop offset={0} stopColor='#025' />
      <stop offset={1} stopColor='#003a7f' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_146_)' d='M214.26 262.16v.72l-6.46 3.73v-.71z' />
    <linearGradient
      id='banner_svg__SVGID_147_'
      gradientUnits='userSpaceOnUse'
      x1={201.338}
      y1={264.389}
      x2={207.802}
      y2={264.389}
    >
      <stop offset={0} stopColor='#025' />
      <stop offset={1} stopColor='#003a7f' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_147_)' d='M201.34 262.16v.72l6.46 3.73v-.71z' />
    <path
      className='banner_svg__st2'
      d='M191.23 230.14c0 .13 0 .26.01.38.02.26.05.51.09.76.08.41.19.81.35 1.2.06.16.13.32.21.47.44.91 1.08 1.76 1.9 2.54 1.01.96 2.28 1.81 3.75 2.51 2.85 1.36 6.46 2.17 10.38 2.17 7.87 0 14.48-3.28 16.23-7.69 0-.01.01-.02.01-.03.15-.38.27-.77.34-1.17.05-.25.08-.51.09-.76v-.78-.02c-.36-5.35-7.69-9.63-16.68-9.63-.16 0-.32 0-.48.01-.13 0-.26 0-.38.01-.1 0-.21.01-.32.01-.07 0-.14.01-.21.01-.23.01-.46.02-.68.04-.08.01-.17.01-.26.02-.04 0-.08.01-.13.01l-.29.03-.33.03-.29.03c-.14.02-.27.03-.41.05h-.03c-.12.02-.25.04-.37.05l-.4.06c-.26.05-.52.09-.78.15h-.01l-.31.06c-.04.01-.07.02-.11.02-.07.02-.14.03-.21.05-.07.02-.14.03-.21.05-.01 0-.02 0-.03.01l-.25.06c-.2.05-.41.1-.6.16-.09.03-.19.05-.28.08-.18.05-.36.11-.54.17l-.18.06-.18.06c-.13.04-.25.09-.37.13-.01 0-.03.01-.04.01-.1.03-.19.07-.29.11-.04.02-.08.03-.12.05-.14.06-.29.11-.43.17-.3.13-.59.25-.88.39l-.24.12c-.31.15-.61.31-.9.48-.09.05-.18.11-.27.16-.01.01-.03.02-.04.02-.07.04-.14.08-.2.12-.04.02-.07.05-.11.07-.07.04-.14.09-.21.13-.05.03-.09.06-.14.09-.06.04-.11.08-.17.12-.23.16-.45.32-.66.49-.06.04-.11.09-.17.14-.12.09-.23.2-.35.3-.03.03-.06.05-.09.08l-.01.01c-.04.04-.09.08-.13.12l-.06.06c-.04.04-.08.08-.12.11l-.03.03-.11.11c-.02.01-.03.03-.05.04v.01c-.04.04-.09.09-.13.14-.03.02-.05.05-.07.07-.02.03-.04.05-.07.07-.1.12-.2.23-.3.35-.03.03-.05.06-.08.1l-.01.01c-.04.06-.09.11-.13.17-.05.06-.09.13-.14.19-.1.14-.2.28-.28.42-.02.04-.04.07-.06.1-.12.2-.23.4-.33.61l-.04.09c0 .01-.01.01-.01.02-.02.05-.05.1-.07.16-.05.1-.09.2-.13.31-.02.06-.05.13-.07.19-.05.16-.1.31-.14.47-.01.03-.02.06-.02.09-.02.07-.03.14-.05.21l-.03.18c0 .01-.01.03-.01.04 0 .02-.01.05-.01.07-.01.06-.02.12-.03.19 0 .02-.01.04-.01.05v.01c-.01.06-.01.13-.02.19 0 .03 0 .06-.01.08v.01c0 .05-.01.1-.01.15V229.9c.04.12.04.18.04.24z'
    />
    <linearGradient
      id='banner_svg__SVGID_148_'
      gradientUnits='userSpaceOnUse'
      x1={202.898}
      y1={229.596}
      x2={210.954}
      y2={229.596}
    >
      <stop offset={0} stopColor='#e9f2ff' />
      <stop offset={1} stopColor='#d4e3ff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_148_)' d='M202.9 229.6l4.03 2.32 4.02-2.32-4.02-2.33z' />
    <linearGradient
      id='banner_svg__SVGID_149_'
      gradientUnits='userSpaceOnUse'
      x1={191.228}
      y1={236.498}
      x2={224.621}
      y2={236.498}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M191.23 232.43c0 .81.15 1.59.46 2.35.43 1.08 1.15 2.1 2.11 3.01 1.01.96 2.28 1.8 3.75 2.51 2.53 1.21 5.66 1.99 9.08 2.14a27.761 27.761 0 002.56 0c7.3-.33 13.3-3.49 14.96-7.66.3-.75.46-1.54.46-2.35 0-.13 0-.26-.01-.39v-1.52c-.01.26-.05.51-.09.76-.07.4-.19.79-.34 1.17 0 .01-.01.02-.01.03-1.66 4.17-7.66 7.33-14.96 7.66a26.593 26.593 0 01-2.56 0c-3.42-.16-6.55-.93-9.08-2.14-1.47-.7-2.74-1.55-3.75-2.51-.82-.78-1.47-1.63-1.9-2.54a4.84 4.84 0 01-.21-.47c-.16-.39-.28-.79-.35-1.2-.05-.25-.08-.51-.09-.76V232.22c-.03.08-.03.15-.03.21z'
      fill='url(#banner_svg__SVGID_149_)'
    />
    <linearGradient
      id='banner_svg__SVGID_150_'
      gradientUnits='userSpaceOnUse'
      x1={202.898}
      y1={230.983}
      x2={206.925}
      y2={230.983}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_150_)' d='M202.9 229.6v.44l4.03 2.33v-.45z' />
    <linearGradient
      id='banner_svg__SVGID_151_'
      gradientUnits='userSpaceOnUse'
      x1={206.925}
      y1={230.983}
      x2={210.954}
      y2={230.983}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_151_)' d='M210.95 229.6v.44l-4.02 2.33v-.45z' />
    <linearGradient
      id='banner_svg__SVGID_152_'
      gradientUnits='userSpaceOnUse'
      x1={206.631}
      y1={252.942}
      x2={209.204}
      y2={252.942}
    >
      <stop offset={0} stopColor='#e9efff' />
      <stop offset={1} stopColor='#d4e3ff' />
    </linearGradient>
    <path
      d='M206.63 262.67v.03c0 .02 0 .04.01.06l.03.09c0 .01.01.02.02.04.03.07.08.14.15.2.08.07.18.14.29.19.22.1.5.17.8.17.61 0 1.12-.25 1.25-.59l.03-.09c0-.02.01-.04.01-.06v-.06V242.45a26.593 26.593 0 01-2.56 0v20.21c-.03 0-.03 0-.03.01z'
      fill='url(#banner_svg__SVGID_152_)'
    />
    <path className='banner_svg__st160' d='M197.4 218.84v14.1l16.29-9.4v-14.11z' />
    <linearGradient
      id='banner_svg__SVGID_153_'
      gradientUnits='userSpaceOnUse'
      x1={196.498}
      y1={225.664}
      x2={197.404}
      y2={225.664}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_153_)' d='M197.4 232.94l-.9-.45v-14.11l.9.46z' />
    <linearGradient
      id='banner_svg__SVGID_154_'
      gradientUnits='userSpaceOnUse'
      x1={196.498}
      y1={213.908}
      x2={213.693}
      y2={213.908}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_154_)' d='M196.5 218.38l16.29-9.4.9.45-16.29 9.41z' />
    <path className='banner_svg__st163' d='M198.22 219.07v12.69l14.65-8.46v-12.69z' />
    <path className='banner_svg__st160' d='M208.4 226.6v2.58l-2.64 1.55v-2.61z' />
    <linearGradient
      id='banner_svg__SVGID_155_'
      gradientUnits='userSpaceOnUse'
      x1={205.372}
      y1={229.424}
      x2={205.762}
      y2={229.424}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_155_)' d='M205.76 230.73l-.39-.26v-2.13l.39-.22z' />
    <path className='banner_svg__st163' d='M218.19 232.27l-3.85-2.22-7.71 4.44 3.85 2.23z' />
    <linearGradient
      id='banner_svg__SVGID_156_'
      gradientUnits='userSpaceOnUse'
      x1={210.503}
      y1={234.7}
      x2={218.208}
      y2={234.7}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_156_)' d='M218.21 232.25v.44l-7.71 4.46v-.45z' />
    <linearGradient
      id='banner_svg__SVGID_157_'
      gradientUnits='userSpaceOnUse'
      x1={206.651}
      y1={235.812}
      x2={210.503}
      y2={235.812}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path fill='url(#banner_svg__SVGID_157_)' d='M210.5 237.15l-3.85-2.2v-.48l3.85 2.23z' />
    <linearGradient
      id='banner_svg__SVGID_158_'
      gradientUnits='userSpaceOnUse'
      x1={163.875}
      y1={237.734}
      x2={165.715}
      y2={237.734}
    >
      <stop offset={0} stopColor='#ff0007' />
      <stop offset={1} stopColor='#ffaaac' />
    </linearGradient>
    <path
      d='M165.71 244.43l-.59.62-1.25-2.02s.13-1.85.51-4.78.18-6.14.18-6.14l1-1.68c.1 1.06.16 2.2.08 3.65-.17 3.55-.39 5.09-.21 7.94.05.83.16 1.66.28 2.41z'
      fill='url(#banner_svg__SVGID_158_)'
    />
    <path
      className='banner_svg__st168'
      d='M177.61 282.45s.61 1.5.48 3.2c-.14 1.7-1.48.82-5.13.02-2.38-.52-4.33-1.09-4.04-1.86.29-.77 5.39-1.51 5.39-1.51l1.62-.17 1.68.32zM173.06 286.94s.62 1.52.48 3.25-1.51.84-5.2.02c-2.42-.53-4.4-1.1-4.1-1.89.3-.78 5.47-1.54 5.47-1.54l1.64-.17 1.71.33z'
    />
    <defs>
      <filter
        id='banner_svg__Adobe_OpacityMaskFilter_10_'
        filterUnits='userSpaceOnUse'
        x={171.49}
        y={239.91}
        width={10}
        height={42.95}
      >
        <feFlood result='back' floodColor='#fff' floodOpacity={1} />
        <feBlend in='SourceGraphic' in2='back' />
      </filter>
    </defs>
    <mask maskUnits='userSpaceOnUse' x={171.49} y={239.91} width={10} height={42.95} id='banner_svg__SVGID_159_'>
      <g filter='url(#banner_svg__Adobe_OpacityMaskFilter_10_)'>
        <defs>
          <filter
            id='banner_svg__Adobe_OpacityMaskFilter_11_'
            filterUnits='userSpaceOnUse'
            x={171.49}
            y={239.91}
            width={10}
            height={42.95}
          >
            <feFlood result='back' floodColor='#fff' floodOpacity={1} />
            <feBlend in='SourceGraphic' in2='back' />
          </filter>
        </defs>
        <linearGradient
          id='banner_svg__SVGID_160_'
          gradientUnits='userSpaceOnUse'
          x1={171.488}
          y1={261.382}
          x2={181.493}
          y2={261.382}
        >
          <stop offset={0} stopColor='#666' />
          <stop offset={0.056} stopColor='#737373' />
          <stop offset={0.284} stopColor='#a5a5a5' />
          <stop offset={0.5} stopColor='#ccc' />
          <stop offset={0.698} stopColor='#e8e8e8' />
          <stop offset={0.87} stopColor='#f9f9f9' />
          <stop offset={0.999} stopColor='#fff' />
        </linearGradient>
        <path
          d='M181.48 241.48s.18 3.87-1.09 5.75-2.65 9.12-2.78 16.28c-.13 7.16 0 18.94 0 18.94s-.85.51-1.85.39-1.45-.54-1.45-.54l-2.82-39.07 1.16-3.32 8.83 1.57z'
          mask='url(#banner_svg__SVGID_159_)'
          fill='url(#banner_svg__SVGID_160_)'
        />
      </g>
    </mask>
    <linearGradient
      id='banner_svg__SVGID_161_'
      gradientUnits='userSpaceOnUse'
      x1={171.488}
      y1={261.382}
      x2={181.493}
      y2={261.382}
    >
      <stop offset={0} stopColor='#e9f2ff' />
      <stop offset={0.547} stopColor='#daeaff' />
      <stop offset={0.999} stopColor='#d4e7ff' />
    </linearGradient>
    <path
      d='M181.48 241.48s.18 3.87-1.09 5.75-2.65 9.12-2.78 16.28c-.13 7.16 0 18.94 0 18.94s-.85.51-1.85.39-1.45-.54-1.45-.54l-2.82-39.07 1.16-3.32 8.83 1.57z'
      fill='url(#banner_svg__SVGID_161_)'
    />
    <path
      className='banner_svg__st2'
      d='M176.99 245.37s.18 3.93-1.11 5.83-2.69 9.26-2.82 16.52c-.13 7.26 0 19.22 0 19.22s-.86.52-1.87.4c-1.01-.12-1.47-.55-1.47-.55l-2.87-39.64 1.18-3.37 8.96 1.59z'
    />
    <linearGradient
      id='banner_svg__SVGID_162_'
      gradientUnits='userSpaceOnUse'
      x1={163.547}
      y1={213.996}
      x2={168.388}
      y2={213.996}
    >
      <stop offset={0} stopColor='#ff7f83' />
      <stop offset={1} stopColor='#ffd4d5' />
    </linearGradient>
    <path
      d='M167.71 214.2c-.84.8-.96 1.96-.96 1.96s-.5.71-.79.67c-.28-.04-2.24-.91-2.24-.91s.58-.96.11-1.54c-.48-.58-.25-1.1-.09-1.45.1-.2.51-.63.96-1.02.58-.49 1.23-.91 1.35-.66.22.45-.85 1.66-.61 1.67h.01c.67 0 1.78-.04 2.92-.33 0 0 .19.81-.66 1.61z'
      fill='url(#banner_svg__SVGID_162_)'
    />
    <linearGradient
      id='banner_svg__SVGID_163_'
      gradientUnits='userSpaceOnUse'
      x1={162.78}
      y1={223.658}
      x2={167.073}
      y2={223.658}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M164 231.51s-1.16-2.26-1.2-8.51c-.04-6.24 0-6.85 0-6.85s1.03-.39 2.12-.34c1.09.04 2.16.45 2.16.45l-.23 4.35-2.85 10.9z'
      fill='url(#banner_svg__SVGID_163_)'
    />
    <linearGradient
      id='banner_svg__SVGID_164_'
      gradientUnits='userSpaceOnUse'
      x1={168.722}
      y1={214.025}
      x2={172.853}
      y2={214.025}
    >
      <stop offset={0} stopColor='#ffd4d5' />
      <stop offset={1} stopColor='#ff7f83' />
    </linearGradient>
    <path
      d='M168.73 212.49s.16 1.84 0 2.98 1.71 2.07 1.77 2.02c.06-.04 2.35-2.39 2.35-2.39l-.55-3.45s-.07-.57-.23-.64c-.17-.06-2.48-.45-2.48-.45l-.86 1.93z'
      fill='url(#banner_svg__SVGID_164_)'
    />
    <linearGradient
      id='banner_svg__SVGID_165_'
      gradientUnits='userSpaceOnUse'
      x1={164.669}
      y1={208.846}
      x2={172.072}
      y2={208.846}
    >
      <stop offset={0} stopColor='#ffd4d5' />
      <stop offset={1} stopColor='#ff7f83' />
    </linearGradient>
    <path
      d='M171.71 210.4c-.72 1.23-2.05 1.86-3.34 2.19-1.14.29-2.25.33-2.92.33h-.01c-.24-.01.82-1.22.61-1.67-.12-.25-.77.17-1.35.66-.05-.68-.06-1.62.12-2.58.35-1.83.72-2.77.72-2.77l2.87-1.78c0-.01 5.02 2.69 3.3 5.62z'
      fill='url(#banner_svg__SVGID_165_)'
    />
    <linearGradient
      id='banner_svg__SVGID_166_'
      gradientUnits='userSpaceOnUse'
      x1={164.914}
      y1={230.698}
      x2={181.505}
      y2={230.698}
    >
      <stop offset={0} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M181.5 241.75s-.63 2.29-4.31 4.13c-3.68 1.84-10.76 1.66-10.76 1.66s-.41-1.33-.72-3.11c-.13-.75-.24-1.58-.29-2.43-.17-2.84.04-4.39.21-7.94.07-1.44.02-2.59-.08-3.65-.15-1.54-.43-2.89-.61-4.71-.3-3.06 1.34-7.83 2.37-9.08s4.15-2.39 4.15-2.39 2.22-.51 4-.37c.72.06 1.32.52 1.76 1.32 0 0 .01.01.02.04.06.11.11.22.17.34 0 .01.01.03.02.04.45 1.05.7 2.55.69 4.41 0 .27 0 .54-.02.82-.12 2.88.53 5.63 1.31 8.32.37 1.27.75 2.54 1.11 3.79 1.1 3.93.98 8.81.98 8.81z'
      fill='url(#banner_svg__SVGID_166_)'
    />
    <linearGradient
      id='banner_svg__SVGID_167_'
      gradientUnits='userSpaceOnUse'
      x1={169.032}
      y1={219.717}
      x2={164.335}
      y2={231.365}
    >
      <stop offset={0.001} stopColor='#6aaeff' />
      <stop offset={1} stopColor='#005eff' />
    </linearGradient>
    <path
      d='M170.22 218.8c-.53-1.29-2.15-1.73-3.22-.84-.64.53-1.31 1.45-1.88 3.04-1.59 4.48-2.31 10.2-.57 11.11 3.62 1.89 5.08-6.07 5.86-9.69.35-1.62.15-2.8-.19-3.62z'
      fill='url(#banner_svg__SVGID_167_)'
    />
    <linearGradient
      id='banner_svg__SVGID_168_'
      gradientUnits='userSpaceOnUse'
      x1={177.44}
      y1={222.394}
      x2={180.919}
      y2={222.394}
    >
      <stop offset={0} stopColor='#005eff' />
      <stop offset={1} stopColor='#6aaeff' />
    </linearGradient>
    <path
      d='M179.42 229.17c-.77-2.69-1.42-5.44-1.31-8.32.09-2.25-.16-4.03-.67-5.23.7 1.47 2.98 6.4 3.43 9.32.26 1.64-.54 3.12-1.45 4.23z'
      fill='url(#banner_svg__SVGID_168_)'
    />
    <defs>
      <filter
        id='banner_svg__Adobe_OpacityMaskFilter_12_'
        filterUnits='userSpaceOnUse'
        x={173.22}
        y={220.03}
        width={8.29}
        height={25.85}
      >
        <feFlood result='back' floodColor='#fff' floodOpacity={1} />
        <feBlend in='SourceGraphic' in2='back' />
      </filter>
    </defs>
    <mask maskUnits='userSpaceOnUse' x={173.22} y={220.03} width={8.29} height={25.85} id='banner_svg__SVGID_169_'>
      <g filter='url(#banner_svg__Adobe_OpacityMaskFilter_12_)'>
        <defs>
          <filter
            id='banner_svg__Adobe_OpacityMaskFilter_13_'
            filterUnits='userSpaceOnUse'
            x={173.22}
            y={220.03}
            width={8.29}
            height={25.85}
          >
            <feFlood result='back' floodColor='#fff' floodOpacity={1} />
            <feBlend in='SourceGraphic' in2='back' />
          </filter>
        </defs>
        <linearGradient
          id='banner_svg__SVGID_170_'
          gradientUnits='userSpaceOnUse'
          x1={173.216}
          y1={232.955}
          x2={181.505}
          y2={232.955}
        >
          <stop offset={0.003} />
          <stop offset={1} stopColor='#fff' />
        </linearGradient>
        <path
          d='M181.5 241.75s-.63 2.29-4.31 4.13c3.42-3.21 2.27-8.67-2.13-9.36s.21-4.57 1.81-5.82-.09-4.34-2.5-4.42c-2.41-.09 3.75-6.25 3.75-6.25 0 .27 0 .54-.02.82-.12 2.88.53 5.63 1.31 8.32.37 1.27.75 2.54 1.11 3.79 1.1 3.91.98 8.79.98 8.79z'
          mask='url(#banner_svg__SVGID_169_)'
          fill='url(#banner_svg__SVGID_170_)'
        />
      </g>
    </mask>
    <linearGradient
      id='banner_svg__SVGID_171_'
      gradientUnits='userSpaceOnUse'
      x1={173.216}
      y1={232.955}
      x2={181.505}
      y2={232.955}
    >
      <stop offset={0.003} stopColor='#6a8cff' />
      <stop offset={1} stopColor='#0011bf' />
    </linearGradient>
    <path
      d='M181.5 241.75s-.63 2.29-4.31 4.13c3.42-3.21 2.27-8.67-2.13-9.36s.21-4.57 1.81-5.82-.09-4.34-2.5-4.42c-2.41-.09 3.75-6.25 3.75-6.25 0 .27 0 .54-.02.82-.12 2.88.53 5.63 1.31 8.32.37 1.27.75 2.54 1.11 3.79 1.1 3.91.98 8.79.98 8.79z'
      fill='url(#banner_svg__SVGID_171_)'
    />
    <path
      className='banner_svg__st168'
      d='M164.22 201.9s-.66 3.01 1.32 4.65c1.98 1.64 1.99 1.87 2.17 2.58.18.72-.19 1.44-.19 1.44s1.49-1.58 1.89-1.06c.4.52-.61 2.04.79 2.35 1.4.32 3.66-.55 4.37-2.1.72-1.55.44-3.01.44-3.01s.18-2.84-1.46-4.02c-1.2-.86-1.45-.14-2.42-.68-.33-.18-.04-1.27-1.28-1.27-.95 0-1.35 1.09-2.44.57-.88-.42.29-1.62-.91-2.17-1.21-.54-2.28 2.72-2.28 2.72z'
    />
    <defs>
      <filter
        id='banner_svg__Adobe_OpacityMaskFilter_14_'
        filterUnits='userSpaceOnUse'
        x={136.15}
        y={286.57}
        width={2.24}
        height={73.43}
      >
        <feFlood result='back' floodColor='#fff' floodOpacity={1} />
        <feBlend in='SourceGraphic' in2='back' />
      </filter>
    </defs>
    <mask maskUnits='userSpaceOnUse' x={136.15} y={286.57} width={2.24} height={73.43} id='banner_svg__SVGID_172_'>
      <g filter='url(#banner_svg__Adobe_OpacityMaskFilter_14_)'>
        <defs>
          <filter
            id='banner_svg__Adobe_OpacityMaskFilter_15_'
            filterUnits='userSpaceOnUse'
            x={136.15}
            y={286.57}
            width={2.24}
            height={73.43}
          >
            <feFlood result='back' floodColor='#fff' floodOpacity={1} />
            <feBlend in='SourceGraphic' in2='back' />
          </filter>
        </defs>
        <linearGradient
          id='banner_svg__SVGID_173_'
          gradientUnits='userSpaceOnUse'
          x1={136.147}
          y1={323.285}
          x2={138.385}
          y2={323.285}
        >
          <stop offset={0} stopColor='#666' />
          <stop offset={0.056} stopColor='#737373' />
          <stop offset={0.284} stopColor='#a5a5a5' />
          <stop offset={0.5} stopColor='#ccc' />
          <stop offset={0.698} stopColor='#e8e8e8' />
          <stop offset={0.87} stopColor='#f9f9f9' />
          <stop offset={0.999} stopColor='#fff' />
        </linearGradient>
        <path
          d='M136.15 286.57s.77 37.86 1.12 73.43c0 0 .79-57.29 1.12-73.43h-2.24z'
          mask='url(#banner_svg__SVGID_172_)'
          fill='url(#banner_svg__SVGID_173_)'
        />
      </g>
    </mask>
    <linearGradient
      id='banner_svg__SVGID_174_'
      gradientUnits='userSpaceOnUse'
      x1={136.147}
      y1={323.285}
      x2={138.385}
      y2={323.285}
    >
      <stop offset={0} stopColor='#e9f2ff' />
      <stop offset={0.277} stopColor='#c7dbff' />
      <stop offset={0.562} stopColor='#abc8ff' />
      <stop offset={0.812} stopColor='#9abdff' />
      <stop offset={0.999} stopColor='#94b9ff' />
    </linearGradient>
    <path d='M136.15 286.57s.77 37.86 1.12 73.43c0 0 .79-57.29 1.12-73.43h-2.24z' fill='url(#banner_svg__SVGID_174_)' />
    <defs>
      <filter
        id='banner_svg__Adobe_OpacityMaskFilter_16_'
        filterUnits='userSpaceOnUse'
        x={128.98}
        y={271.73}
        width={16.56}
        height={16.56}
      >
        <feFlood result='back' floodColor='#fff' floodOpacity={1} />
        <feBlend in='SourceGraphic' in2='back' />
      </filter>
    </defs>
    <mask maskUnits='userSpaceOnUse' x={128.98} y={271.73} width={16.56} height={16.56} id='banner_svg__SVGID_175_'>
      <g filter='url(#banner_svg__Adobe_OpacityMaskFilter_16_)'>
        <defs>
          <filter
            id='banner_svg__Adobe_OpacityMaskFilter_17_'
            filterUnits='userSpaceOnUse'
            x={128.98}
            y={271.73}
            width={16.56}
            height={16.56}
          >
            <feFlood result='back' floodColor='#fff' floodOpacity={1} />
            <feBlend in='SourceGraphic' in2='back' />
          </filter>
        </defs>
        <linearGradient
          id='banner_svg__SVGID_176_'
          gradientUnits='userSpaceOnUse'
          x1={145.547}
          y1={280.016}
          x2={128.985}
          y2={280.016}
        >
          <stop offset={0} stopColor='#666' />
          <stop offset={0.056} stopColor='#737373' />
          <stop offset={0.284} stopColor='#a5a5a5' />
          <stop offset={0.5} stopColor='#ccc' />
          <stop offset={0.698} stopColor='#e8e8e8' />
          <stop offset={0.87} stopColor='#f9f9f9' />
          <stop offset={0.999} stopColor='#fff' />
        </linearGradient>
        <circle
          cx={137.27}
          cy={280.02}
          r={8.28}
          mask='url(#banner_svg__SVGID_175_)'
          fill='url(#banner_svg__SVGID_176_)'
        />
      </g>
    </mask>
    <linearGradient
      id='banner_svg__SVGID_177_'
      gradientUnits='userSpaceOnUse'
      x1={145.547}
      y1={280.016}
      x2={128.985}
      y2={280.016}
    >
      <stop offset={0} stopColor='#e9f2ff' />
      <stop offset={0.277} stopColor='#c7dbff' />
      <stop offset={0.562} stopColor='#abc8ff' />
      <stop offset={0.812} stopColor='#9abdff' />
      <stop offset={0.999} stopColor='#94b9ff' />
    </linearGradient>
    <circle cx={137.27} cy={280.02} r={8.28} fill='url(#banner_svg__SVGID_177_)' />
    <defs>
      <filter
        id='banner_svg__Adobe_OpacityMaskFilter_18_'
        filterUnits='userSpaceOnUse'
        x={311.86}
        y={75.38}
        width={2.38}
        height={55.82}
      >
        <feFlood result='back' floodColor='#fff' floodOpacity={1} />
        <feBlend in='SourceGraphic' in2='back' />
      </filter>
    </defs>
    <mask maskUnits='userSpaceOnUse' x={311.86} y={75.38} width={2.38} height={55.82} id='banner_svg__SVGID_178_'>
      <g filter='url(#banner_svg__Adobe_OpacityMaskFilter_18_)'>
        <defs>
          <filter
            id='banner_svg__Adobe_OpacityMaskFilter_19_'
            filterUnits='userSpaceOnUse'
            x={311.86}
            y={75.38}
            width={2.38}
            height={55.82}
          >
            <feFlood result='back' floodColor='#fff' floodOpacity={1} />
            <feBlend in='SourceGraphic' in2='back' />
          </filter>
        </defs>
        <linearGradient
          id='banner_svg__SVGID_179_'
          gradientUnits='userSpaceOnUse'
          x1={311.858}
          y1={103.292}
          x2={314.243}
          y2={103.292}
        >
          <stop offset={0} stopColor='#666' />
          <stop offset={0.056} stopColor='#737373' />
          <stop offset={0.284} stopColor='#a5a5a5' />
          <stop offset={0.5} stopColor='#ccc' />
          <stop offset={0.698} stopColor='#e8e8e8' />
          <stop offset={0.87} stopColor='#f9f9f9' />
          <stop offset={0.999} stopColor='#fff' />
        </linearGradient>
        <path
          d='M311.86 75.38s.82 28.78 1.19 55.82c0 0 .84-43.55 1.19-55.82h-2.38z'
          mask='url(#banner_svg__SVGID_178_)'
          fill='url(#banner_svg__SVGID_179_)'
        />
      </g>
    </mask>
    <linearGradient
      id='banner_svg__SVGID_180_'
      gradientUnits='userSpaceOnUse'
      x1={311.858}
      y1={103.292}
      x2={314.243}
      y2={103.292}
    >
      <stop offset={0} stopColor='#e9f2ff' />
      <stop offset={0.277} stopColor='#c7dbff' />
      <stop offset={0.562} stopColor='#abc8ff' />
      <stop offset={0.812} stopColor='#9abdff' />
      <stop offset={0.999} stopColor='#94b9ff' />
    </linearGradient>
    <path d='M311.86 75.38s.82 28.78 1.19 55.82c0 0 .84-43.55 1.19-55.82h-2.38z' fill='url(#banner_svg__SVGID_180_)' />
    <defs>
      <filter
        id='banner_svg__Adobe_OpacityMaskFilter_20_'
        filterUnits='userSpaceOnUse'
        x={304.23}
        y={59.57}
        width={17.65}
        height={17.65}
      >
        <feFlood result='back' floodColor='#fff' floodOpacity={1} />
        <feBlend in='SourceGraphic' in2='back' />
      </filter>
    </defs>
    <mask maskUnits='userSpaceOnUse' x={304.23} y={59.57} width={17.65} height={17.65} id='banner_svg__SVGID_181_'>
      <g filter='url(#banner_svg__Adobe_OpacityMaskFilter_20_)'>
        <defs>
          <filter
            id='banner_svg__Adobe_OpacityMaskFilter_21_'
            filterUnits='userSpaceOnUse'
            x={304.23}
            y={59.57}
            width={17.65}
            height={17.65}
          >
            <feFlood result='back' floodColor='#fff' floodOpacity={1} />
            <feBlend in='SourceGraphic' in2='back' />
          </filter>
        </defs>
        <linearGradient
          id='banner_svg__SVGID_182_'
          gradientUnits='userSpaceOnUse'
          x1={321.875}
          y1={68.398}
          x2={304.226}
          y2={68.398}
        >
          <stop offset={0} stopColor='#666' />
          <stop offset={0.056} stopColor='#737373' />
          <stop offset={0.284} stopColor='#a5a5a5' />
          <stop offset={0.5} stopColor='#ccc' />
          <stop offset={0.698} stopColor='#e8e8e8' />
          <stop offset={0.87} stopColor='#f9f9f9' />
          <stop offset={0.999} stopColor='#fff' />
        </linearGradient>
        <circle
          cx={313.05}
          cy={68.4}
          r={8.82}
          mask='url(#banner_svg__SVGID_181_)'
          fill='url(#banner_svg__SVGID_182_)'
        />
      </g>
    </mask>
    <linearGradient
      id='banner_svg__SVGID_183_'
      gradientUnits='userSpaceOnUse'
      x1={321.875}
      y1={68.398}
      x2={304.226}
      y2={68.398}
    >
      <stop offset={0} stopColor='#e9f2ff' />
      <stop offset={0.277} stopColor='#c7dbff' />
      <stop offset={0.562} stopColor='#abc8ff' />
      <stop offset={0.812} stopColor='#9abdff' />
      <stop offset={0.999} stopColor='#94b9ff' />
    </linearGradient>
    <circle cx={313.05} cy={68.4} r={8.82} fill='url(#banner_svg__SVGID_183_)' />
    <defs>
      <filter
        id='banner_svg__Adobe_OpacityMaskFilter_22_'
        filterUnits='userSpaceOnUse'
        x={309.12}
        y={237.44}
        width={2.38}
        height={55.82}
      >
        <feFlood result='back' floodColor='#fff' floodOpacity={1} />
        <feBlend in='SourceGraphic' in2='back' />
      </filter>
    </defs>
    <mask maskUnits='userSpaceOnUse' x={309.12} y={237.44} width={2.38} height={55.82} id='banner_svg__SVGID_184_'>
      <g filter='url(#banner_svg__Adobe_OpacityMaskFilter_22_)'>
        <defs>
          <filter
            id='banner_svg__Adobe_OpacityMaskFilter_23_'
            filterUnits='userSpaceOnUse'
            x={309.12}
            y={237.44}
            width={2.38}
            height={55.82}
          >
            <feFlood result='back' floodColor='#fff' floodOpacity={1} />
            <feBlend in='SourceGraphic' in2='back' />
          </filter>
        </defs>
        <linearGradient
          id='banner_svg__SVGID_185_'
          gradientUnits='userSpaceOnUse'
          x1={309.118}
          y1={265.347}
          x2={311.503}
          y2={265.347}
        >
          <stop offset={0} stopColor='#666' />
          <stop offset={0.056} stopColor='#737373' />
          <stop offset={0.284} stopColor='#a5a5a5' />
          <stop offset={0.5} stopColor='#ccc' />
          <stop offset={0.698} stopColor='#e8e8e8' />
          <stop offset={0.87} stopColor='#f9f9f9' />
          <stop offset={0.999} stopColor='#fff' />
        </linearGradient>
        <path
          d='M309.12 237.44s.82 28.78 1.19 55.82c0 0 .84-43.55 1.19-55.82h-2.38z'
          mask='url(#banner_svg__SVGID_184_)'
          fill='url(#banner_svg__SVGID_185_)'
        />
      </g>
    </mask>
    <linearGradient
      id='banner_svg__SVGID_186_'
      gradientUnits='userSpaceOnUse'
      x1={309.118}
      y1={265.347}
      x2={311.503}
      y2={265.347}
    >
      <stop offset={0} stopColor='#e9f2ff' />
      <stop offset={0.277} stopColor='#c7dbff' />
      <stop offset={0.562} stopColor='#abc8ff' />
      <stop offset={0.812} stopColor='#9abdff' />
      <stop offset={0.999} stopColor='#94b9ff' />
    </linearGradient>
    <path d='M309.12 237.44s.82 28.78 1.19 55.82c0 0 .84-43.55 1.19-55.82h-2.38z' fill='url(#banner_svg__SVGID_186_)' />
    <defs>
      <filter
        id='banner_svg__Adobe_OpacityMaskFilter_24_'
        filterUnits='userSpaceOnUse'
        x={301.49}
        y={221.63}
        width={17.65}
        height={17.65}
      >
        <feFlood result='back' floodColor='#fff' floodOpacity={1} />
        <feBlend in='SourceGraphic' in2='back' />
      </filter>
    </defs>
    <mask maskUnits='userSpaceOnUse' x={301.49} y={221.63} width={17.65} height={17.65} id='banner_svg__SVGID_187_'>
      <g filter='url(#banner_svg__Adobe_OpacityMaskFilter_24_)'>
        <defs>
          <filter
            id='banner_svg__Adobe_OpacityMaskFilter_25_'
            filterUnits='userSpaceOnUse'
            x={301.49}
            y={221.63}
            width={17.65}
            height={17.65}
          >
            <feFlood result='back' floodColor='#fff' floodOpacity={1} />
            <feBlend in='SourceGraphic' in2='back' />
          </filter>
        </defs>
        <linearGradient
          id='banner_svg__SVGID_188_'
          gradientUnits='userSpaceOnUse'
          x1={319.136}
          y1={230.453}
          x2={301.486}
          y2={230.453}
        >
          <stop offset={0} stopColor='#666' />
          <stop offset={0.056} stopColor='#737373' />
          <stop offset={0.284} stopColor='#a5a5a5' />
          <stop offset={0.5} stopColor='#ccc' />
          <stop offset={0.698} stopColor='#e8e8e8' />
          <stop offset={0.87} stopColor='#f9f9f9' />
          <stop offset={0.999} stopColor='#fff' />
        </linearGradient>
        <circle
          cx={310.31}
          cy={230.45}
          r={8.82}
          mask='url(#banner_svg__SVGID_187_)'
          fill='url(#banner_svg__SVGID_188_)'
        />
      </g>
    </mask>
    <linearGradient
      id='banner_svg__SVGID_189_'
      gradientUnits='userSpaceOnUse'
      x1={319.136}
      y1={230.453}
      x2={301.486}
      y2={230.453}
    >
      <stop offset={0} stopColor='#e9f2ff' />
      <stop offset={0.277} stopColor='#c7dbff' />
      <stop offset={0.562} stopColor='#abc8ff' />
      <stop offset={0.812} stopColor='#9abdff' />
      <stop offset={0.999} stopColor='#94b9ff' />
    </linearGradient>
    <circle cx={310.31} cy={230.45} r={8.82} fill='url(#banner_svg__SVGID_189_)' />
    <defs>
      <filter
        id='banner_svg__Adobe_OpacityMaskFilter_26_'
        filterUnits='userSpaceOnUse'
        x={13.69}
        y={262.66}
        width={2.38}
        height={55.82}
      >
        <feFlood result='back' floodColor='#fff' floodOpacity={1} />
        <feBlend in='SourceGraphic' in2='back' />
      </filter>
    </defs>
    <mask maskUnits='userSpaceOnUse' x={13.69} y={262.66} width={2.38} height={55.82} id='banner_svg__SVGID_190_'>
      <g filter='url(#banner_svg__Adobe_OpacityMaskFilter_26_)'>
        <defs>
          <filter
            id='banner_svg__Adobe_OpacityMaskFilter_27_'
            filterUnits='userSpaceOnUse'
            x={13.69}
            y={262.66}
            width={2.38}
            height={55.82}
          >
            <feFlood result='back' floodColor='#fff' floodOpacity={1} />
            <feBlend in='SourceGraphic' in2='back' />
          </filter>
        </defs>
        <linearGradient
          id='banner_svg__SVGID_191_'
          gradientUnits='userSpaceOnUse'
          x1={13.69}
          y1={290.565}
          x2={16.075}
          y2={290.565}
        >
          <stop offset={0} stopColor='#666' />
          <stop offset={0.056} stopColor='#737373' />
          <stop offset={0.284} stopColor='#a5a5a5' />
          <stop offset={0.5} stopColor='#ccc' />
          <stop offset={0.698} stopColor='#e8e8e8' />
          <stop offset={0.87} stopColor='#f9f9f9' />
          <stop offset={0.999} stopColor='#fff' />
        </linearGradient>
        <path
          d='M13.69 262.66s.82 28.78 1.19 55.82c0 0 .84-43.55 1.19-55.82h-2.38z'
          mask='url(#banner_svg__SVGID_190_)'
          fill='url(#banner_svg__SVGID_191_)'
        />
      </g>
    </mask>
    <linearGradient
      id='banner_svg__SVGID_192_'
      gradientUnits='userSpaceOnUse'
      x1={13.69}
      y1={290.565}
      x2={16.075}
      y2={290.565}
    >
      <stop offset={0} stopColor='#e9f2ff' />
      <stop offset={0.277} stopColor='#c7dbff' />
      <stop offset={0.562} stopColor='#abc8ff' />
      <stop offset={0.812} stopColor='#9abdff' />
      <stop offset={0.999} stopColor='#94b9ff' />
    </linearGradient>
    <path d='M13.69 262.66s.82 28.78 1.19 55.82c0 0 .84-43.55 1.19-55.82h-2.38z' fill='url(#banner_svg__SVGID_192_)' />
    <defs>
      <filter
        id='banner_svg__Adobe_OpacityMaskFilter_28_'
        filterUnits='userSpaceOnUse'
        x={6.06}
        y={246.85}
        width={17.65}
        height={17.65}
      >
        <feFlood result='back' floodColor='#fff' floodOpacity={1} />
        <feBlend in='SourceGraphic' in2='back' />
      </filter>
    </defs>
    <mask maskUnits='userSpaceOnUse' x={6.06} y={246.85} width={17.65} height={17.65} id='banner_svg__SVGID_193_'>
      <g filter='url(#banner_svg__Adobe_OpacityMaskFilter_28_)'>
        <defs>
          <filter
            id='banner_svg__Adobe_OpacityMaskFilter_29_'
            filterUnits='userSpaceOnUse'
            x={6.06}
            y={246.85}
            width={17.65}
            height={17.65}
          >
            <feFlood result='back' floodColor='#fff' floodOpacity={1} />
            <feBlend in='SourceGraphic' in2='back' />
          </filter>
        </defs>
        <linearGradient
          id='banner_svg__SVGID_194_'
          gradientUnits='userSpaceOnUse'
          x1={23.707}
          y1={255.671}
          x2={6.058}
          y2={255.671}
        >
          <stop offset={0} stopColor='#666' />
          <stop offset={0.056} stopColor='#737373' />
          <stop offset={0.284} stopColor='#a5a5a5' />
          <stop offset={0.5} stopColor='#ccc' />
          <stop offset={0.698} stopColor='#e8e8e8' />
          <stop offset={0.87} stopColor='#f9f9f9' />
          <stop offset={0.999} stopColor='#fff' />
        </linearGradient>
        <circle
          cx={14.88}
          cy={255.67}
          r={8.82}
          mask='url(#banner_svg__SVGID_193_)'
          fill='url(#banner_svg__SVGID_194_)'
        />
      </g>
    </mask>
    <linearGradient
      id='banner_svg__SVGID_195_'
      gradientUnits='userSpaceOnUse'
      x1={23.707}
      y1={255.671}
      x2={6.058}
      y2={255.671}
    >
      <stop offset={0} stopColor='#e9f2ff' />
      <stop offset={0.277} stopColor='#c7dbff' />
      <stop offset={0.562} stopColor='#abc8ff' />
      <stop offset={0.812} stopColor='#9abdff' />
      <stop offset={0.999} stopColor='#94b9ff' />
    </linearGradient>
    <circle cx={14.88} cy={255.67} r={8.82} fill='url(#banner_svg__SVGID_195_)' />
  </svg>
)

export default SvgBanner
